class x extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll(".kik-hero-slide")), this.dots = Array.from(this.querySelectorAll(".kik-hero-dot")), !(this.slides.length <= 1) && (this.index = Math.max(0, this.slides.findIndex((t) => t.classList.contains("is-active"))), this.autoplay = this.dataset.autoplay === "true", this.speed = Math.max(2, parseFloat(this.dataset.speed || "5")) * 1e3, this.isStatic = this.hasAttribute("data-static"), this.dots.forEach((t, e) => {
      t.addEventListener("click", () => this.goTo(e));
    }), this.addEventListener("mouseenter", () => this.stop()), this.addEventListener("mouseleave", () => this.start()), this.addEventListener("focusin", () => this.stop()), this.addEventListener("focusout", () => this.start()), document.addEventListener("visibilitychange", () => {
      document.hidden ? this.stop() : this.start();
    }), this.bindSwipe(), this.autoplay && !this.prefersReducedMotion() && this.start());
  }
  /* Touch / pointer swipe: horizontal drag past the threshold advances the
   * slideshow. `touch-action: pan-y` keeps vertical page scroll native while
   * letting horizontal gestures reach us instead of being cancelled. */
  bindSwipe() {
    this.style.touchAction = "pan-y", this.swipeThreshold = 40, this.swipe = null, this.addEventListener("pointerdown", (e) => {
      e.pointerType === "mouse" && e.button !== 0 || (this.swipe = { id: e.pointerId, x: e.clientX, y: e.clientY }, this.stop());
    }, { passive: !0 });
    const t = (e) => {
      const i = this.swipe;
      if (!i || e.pointerId !== i.id) return;
      this.swipe = null;
      const s = e.clientX - i.x, r = e.clientY - i.y;
      Math.abs(s) >= this.swipeThreshold && Math.abs(s) > Math.abs(r) && (s < 0 ? this.next() : this.prev()), this.start();
    };
    this.addEventListener("pointerup", t, { passive: !0 }), this.addEventListener("pointercancel", () => {
      this.swipe = null, this.start();
    }, { passive: !0 });
  }
  disconnectedCallback() {
    this.stop();
  }
  prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }
  goTo(t) {
    if (t === this.index) return;
    const e = this.slides[this.index], i = this.slides[t];
    !e || !i || (e.classList.remove("is-active"), e.setAttribute("aria-hidden", "true"), e.setAttribute("tabindex", "-1"), i.classList.add("is-active"), i.removeAttribute("aria-hidden"), i.removeAttribute("tabindex"), this.dots[this.index]?.classList.remove("is-active"), this.dots[t]?.classList.add("is-active"), this.index = t);
  }
  next() {
    this.goTo((this.index + 1) % this.slides.length);
  }
  prev() {
    this.goTo((this.index - 1 + this.slides.length) % this.slides.length);
  }
  start() {
    !this.autoplay || this.timer || (this.timer = setInterval(() => this.next(), this.speed));
  }
  stop() {
    this.timer && (clearInterval(this.timer), this.timer = null);
  }
}
customElements.get("kik-hero-slideshow") || customElements.define("kik-hero-slideshow", x);
class M extends HTMLElement {
  connectedCallback() {
    const t = this.querySelector(".kik-fc-heading, [data-kik-reveal-hidden]"), e = () => {
      this.classList.add("is-visible"), t && t.removeAttribute("data-kik-reveal-hidden");
    };
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      e();
      return;
    }
    if (!("IntersectionObserver" in window)) {
      e();
      return;
    }
    const i = new IntersectionObserver(
      (s) => {
        s.forEach((r) => {
          r.isIntersecting && (e(), i.disconnect());
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -10% 0px" }
    );
    i.observe(this);
  }
}
customElements.get("kik-scroll-reveal") || customElements.define("kik-scroll-reveal", M);
class _ extends HTMLElement {
  connectedCallback() {
    let t = !1, e = !1, i = 0, s = 0, r = 0, o = 0, a = 0, c = null;
    const l = 3, h = () => {
      c && (cancelAnimationFrame(c), c = null);
    }, d = () => {
      h();
      const u = () => {
        if (Math.abs(a) < 0.3) {
          c = null;
          return;
        }
        this.scrollLeft -= a, a *= 0.92, c = requestAnimationFrame(u);
      };
      c = requestAnimationFrame(u);
    }, m = (u) => {
      h(), t = !0, e = !1;
      const g = u.touches ? u.touches[0].pageX : u.pageX;
      i = g, r = g, o = performance.now(), s = this.scrollLeft, a = 0;
    }, f = (u) => {
      if (!t) return;
      const g = u.touches ? u.touches[0].pageX : u.pageX, b = g - i;
      if (Math.abs(b) > l && !e && (e = !0, this.classList.add("is-dragging")), !e) return;
      u.cancelable && u.preventDefault(), this.scrollLeft = s - b;
      const S = performance.now(), E = S - o;
      E > 0 && (a = 0.8 * ((g - r) / E) * 16 + 0.2 * a), r = g, o = S;
    }, w = () => {
      t && (t = !1, e && (setTimeout(() => this.classList.remove("is-dragging"), 0), Math.abs(a) > 1 && d()), e = !1);
    };
    this.addEventListener("mousedown", m), this.addEventListener("mousemove", f), window.addEventListener("mouseup", w), this.addEventListener("mouseleave", w), this.addEventListener("wheel", h, { passive: !0 }), this.addEventListener("click", (u) => {
      this.classList.contains("is-dragging") && (u.preventDefault(), u.stopPropagation());
    }, !0);
  }
}
customElements.get("kik-drag-scroll") || customElements.define("kik-drag-scroll", _);
class R extends HTMLElement {
  connectedCallback() {
    this.setupTabs(), this.setupReveal(), this.setupScrollMorph();
  }
  disconnectedCallback() {
    this._onScroll && window.removeEventListener("scroll", this._onScroll), this._onResize && window.removeEventListener("resize", this._onResize);
  }
  setupTabs() {
    const t = this.querySelectorAll(".kik-mg-tab"), e = this.querySelectorAll(".kik-mg-panel");
    t.length && t.forEach((i) => {
      i.addEventListener("click", () => {
        const s = i.dataset.tabKey;
        t.forEach((r) => {
          const o = r.dataset.tabKey === s;
          r.classList.toggle("is-active", o), r.setAttribute("aria-selected", o ? "true" : "false");
        }), e.forEach((r) => {
          r.classList.toggle("is-active", r.dataset.tabKey === s);
        });
      });
    });
  }
  setupReveal() {
    if (this.hasAttribute("data-static")) {
      this.classList.add("is-visible");
      return;
    }
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.classList.add("is-visible");
      return;
    }
    if (!("IntersectionObserver" in window)) {
      this.classList.add("is-visible");
      return;
    }
    const t = new IntersectionObserver(
      (e) => {
        e.forEach((i) => {
          i.isIntersecting && (this.classList.add("is-visible"), t.disconnect());
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -10% 0px" }
    );
    t.observe(this);
  }
  setupScrollMorph() {
    if (this.dataset.scrollMorph !== "on") return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.classList.add("is-morphed");
      return;
    }
    if (window.innerWidth < 1200) {
      this.classList.add("is-morphed");
      return;
    }
    const t = () => {
      if (window.innerWidth < 1200) {
        this.classList.add("is-morphed");
        return;
      }
      const i = this.getBoundingClientRect(), s = window.innerHeight * 0.3;
      i.top <= s ? this.classList.add("is-morphed") : this.classList.remove("is-morphed");
    };
    let e = !1;
    this._onScroll = () => {
      e || (requestAnimationFrame(() => {
        t(), e = !1;
      }), e = !0);
    }, this._onResize = t, window.addEventListener("scroll", this._onScroll, { passive: !0 }), window.addEventListener("resize", this._onResize, { passive: !0 }), t();
  }
}
customElements.get("kik-media-grid") || customElements.define("kik-media-grid", R);
const I = 140, D = 1600;
class H extends HTMLElement {
  connectedCallback() {
    this.links = Array.from(this.querySelectorAll("a[data-target]")), this.links.length !== 0 && (this.offset = Number(this.dataset.offset || 0) || 0, this.gap = Number(this.dataset.scrollGap || 0) || 0, this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches, this.entries = this.links.map((t) => ({ link: t, target: document.getElementById(t.dataset.target) })).filter((t) => t.target).sort(
      (t, e) => t.target.compareDocumentPosition(e.target) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1
    ), this.onClick = this.onClick.bind(this), this.onScroll = this.onScroll.bind(this), this.links.forEach((t) => t.addEventListener("click", this.onClick)), this.setupDragScroll(), this.setActive(this.links[0]), this.entries.length > 0 && (window.addEventListener("scroll", this.onScroll, { passive: !0 }), window.addEventListener("resize", this.onScroll, { passive: !0 }), this.syncActive()));
  }
  // Touch already pans the overflowing row natively; a mouse can't, and the
  // scrollbar is hidden. Add click-and-drag panning for mouse pointers only.
  setupDragScroll() {
    const t = this.querySelector(".kik-sticky-nav__row");
    if (!t || this.dragAbort)
      return;
    this.dragAbort = new AbortController();
    const { signal: e } = this.dragAbort, i = 4;
    let s = !1, r = !1, o = 0, a = 0;
    t.addEventListener(
      "pointerdown",
      (l) => {
        l.pointerType !== "mouse" || l.button !== 0 || t.scrollWidth <= t.clientWidth + 1 || (s = !0, r = !1, o = l.clientX, a = t.scrollLeft);
      },
      { signal: e }
    ), window.addEventListener(
      "pointermove",
      (l) => {
        if (!s)
          return;
        const h = l.clientX - o;
        !r && Math.abs(h) > i && (r = !0, t.classList.add("is-dragging")), r && (t.scrollLeft = a - h);
      },
      { signal: e }
    );
    const c = () => {
      s && (s = !1, setTimeout(() => t.classList.remove("is-dragging"), 0));
    };
    window.addEventListener("pointerup", c, { signal: e }), window.addEventListener("pointercancel", c, { signal: e }), t.addEventListener(
      "click",
      (l) => {
        t.classList.contains("is-dragging") && (l.preventDefault(), l.stopImmediatePropagation());
      },
      { capture: !0, signal: e }
    ), t.addEventListener("dragstart", (l) => l.preventDefault(), { signal: e });
  }
  disconnectedCallback() {
    this.dragAbort?.abort(), this.dragAbort = null, this.links?.forEach((t) => t.removeEventListener("click", this.onClick)), window.removeEventListener("scroll", this.onScroll), window.removeEventListener("resize", this.onScroll), this.frame && cancelAnimationFrame(this.frame), clearTimeout(this.settleTimer), clearTimeout(this.settleCap);
  }
  // The sticky element is the section wrapper (schema `class`), not this
  // element — read its resolved `top` so the mobile offset and the header
  // show/hide rule are both accounted for.
  stickyRoot() {
    return this.closest(".cc-kik-sticky-nav") || this.closest("section") || this;
  }
  stickyInset() {
    const t = this.stickyRoot();
    let e = this.offset;
    const i = window.getComputedStyle(t);
    if (i.position === "sticky") {
      const s = parseFloat(i.top);
      Number.isNaN(s) || (e = s);
    }
    return Math.round(t.getBoundingClientRect().height + Math.max(e, 0));
  }
  // Where a clicked target should land: just below the bar, plus the gap.
  scrollInset() {
    return this.stickyInset() + this.gap;
  }
  onClick(t) {
    const e = t.currentTarget, i = e.dataset.target;
    if (!i)
      return;
    const s = document.getElementById(i);
    if (!s)
      return;
    t.preventDefault(), this.setActive(e), this.lock();
    const r = s.getBoundingClientRect().top + window.scrollY - this.scrollInset();
    window.scrollTo({ top: Math.max(r, 0), behavior: this.reduceMotion ? "auto" : "smooth" });
  }
  lock() {
    this.locked = !0, clearTimeout(this.settleCap), this.settleCap = setTimeout(() => this.unlock(), D), this.armSettle();
  }
  armSettle() {
    clearTimeout(this.settleTimer), this.settleTimer = setTimeout(() => this.unlock(), I);
  }
  unlock() {
    this.locked = !1, clearTimeout(this.settleTimer), clearTimeout(this.settleCap);
  }
  onScroll() {
    if (this.locked) {
      this.armSettle();
      return;
    }
    this.frame || (this.frame = requestAnimationFrame(() => {
      this.frame = 0, this.syncActive();
    }));
  }
  // Prefer the section CURRENTLY straddling the spy line (top scrolled past it,
  // bottom still below it) — that's the section whose content is visible right
  // under the sticky bar. Fall back to "last section that passed" when the user
  // sits in an unanchored gap between two nav-targeted sections, so the most
  // recently visited nav item stays lit rather than clearing.
  syncActive() {
    if (!this.entries || this.entries.length === 0)
      return;
    const t = this.stickyInset() + this.gap, e = document.documentElement;
    if (window.innerHeight + window.scrollY >= e.scrollHeight - 2) {
      this.setActive(this.entries[this.entries.length - 1].link);
      return;
    }
    let s = null;
    for (const r of this.entries) {
      const o = r.target.getBoundingClientRect();
      if (o.top <= t && o.bottom > t) {
        s = r;
        break;
      }
    }
    if (!s)
      for (const r of this.entries)
        r.target.getBoundingClientRect().top <= t && (s = r);
    this.setActive((s || this.entries[0]).link);
  }
  setActive(t) {
    this.activeLink !== t && (this.activeLink = t, this.links.forEach((e) => {
      const i = e === t;
      e.classList.toggle("is-active", i), i ? e.setAttribute("aria-current", "true") : e.removeAttribute("aria-current");
    }), this.scrollActiveIntoView());
  }
  // On mobile the row overflows horizontally (justify-start + overflow-x-auto).
  // When scroll-spy activates a link that's clipped off either edge, nudge the
  // row so the active item is visible. No-op on desktop where the row fits.
  scrollActiveIntoView() {
    const t = this.querySelector(".kik-sticky-nav__row");
    if (!t || !this.activeLink || t.scrollWidth <= t.clientWidth + 1)
      return;
    const e = t.getBoundingClientRect(), i = this.activeLink.getBoundingClientRect(), s = 24;
    let r = 0;
    i.left < e.left + s ? r = i.left - e.left - s : i.right > e.right - s && (r = i.right - e.right + s), r !== 0 && t.scrollBy({ left: r, behavior: this.reduceMotion ? "auto" : "smooth" });
  }
}
customElements.get("kik-sticky-nav") || customElements.define("kik-sticky-nav", H);
class P extends HTMLElement {
  connectedCallback() {
    if (this.tabs = Array.from(this.querySelectorAll("[data-kik-tab]")), this.panels = Array.from(this.querySelectorAll("[data-kik-tab-panel]")), this.tabs.length === 0)
      return;
    this.onClick = this.onClick.bind(this), this.onKeydown = this.onKeydown.bind(this), this.tabs.forEach((e) => {
      e.addEventListener("click", this.onClick), e.addEventListener("keydown", this.onKeydown);
    });
    const t = this.tabs.findIndex((e) => e.classList.contains("is-active"));
    this.activate(t < 0 ? 0 : t), this.initScrollReveal();
  }
  disconnectedCallback() {
    this.tabs?.forEach((t) => {
      t.removeEventListener("click", this.onClick), t.removeEventListener("keydown", this.onKeydown);
    }), this.onScroll && window.removeEventListener("scroll", this.onScroll), this.onResize && window.removeEventListener("resize", this.onResize);
  }
  // Scroll-scrubbed reveal: while the banner is pinned, the background media
  // clip-path expands from inset(20% 40% round 20px) to inset(0%), and once that
  // is almost done the heading + tab row slide up from translateY(200px) to 0.
  // Progress is exposed as CSS vars (--ftb-p images, --ftb-t text) on this
  // element; the section's stylesheet interpolates against them.
  initScrollReveal() {
    this.pin = this.querySelector(".kik-ftb__pin");
    const t = this.dataset.scrollAnim !== "false", e = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    !this.pin || !t || e || (this.section = this.closest(".kik-ftb") || this, this.section.classList.add("kik-ftb--anim"), this.ticking = !1, this.syncViewportLayout(), this.stickyTop = this.readStickyTop(), this.onScroll = this.onScroll.bind(this), this.onResize = this.onResize.bind(this), window.addEventListener("scroll", this.onScroll, { passive: !0 }), window.addEventListener("resize", this.onResize), this.updateReveal());
  }
  // The pin sticks at `top: <offset>` (below a sticky header), so the reveal
  // must start when the track top reaches that offset, not 0.
  readStickyTop() {
    return parseFloat(window.getComputedStyle(this.pin).top) || 0;
  }
  onScroll() {
    this.ticking || (this.ticking = !0, requestAnimationFrame(() => {
      this.updateReveal(), this.ticking = !1;
    }));
  }
  onResize() {
    this.syncViewportLayout(), this.stickyTop = this.readStickyTop(), this.updateReveal();
  }
  syncViewportLayout() {
    if (!this.section || !this.pin || !window.matchMedia("(min-width: 769px)").matches) {
      this.section?.style.removeProperty("--kik-ftb-sticky-top");
      return;
    }
    let t = 0;
    for (const e of [".kik-header-section", ".cc-kik-sticky-nav"]) {
      const i = document.querySelector(e);
      if (!i) continue;
      const s = window.getComputedStyle(i);
      if (s.position !== "sticky" && s.position !== "fixed") continue;
      const r = i.getBoundingClientRect(), o = Number.parseFloat(s.top);
      Number.isFinite(o) && r.top <= o + 1 && r.bottom > 0 && r.top < window.innerHeight && (t = Math.max(t, r.bottom));
    }
    this.section.style.setProperty("--kik-ftb-sticky-top", `${Math.max(0, Math.ceil(t))}px`);
  }
  updateReveal() {
    const t = Math.max(0, window.innerHeight * 0.5 - this.stickyTop), e = this.offsetHeight - this.pin.offsetHeight + t, i = this.stickyTop + t, s = e > 0 ? Math.min(Math.max((i - this.getBoundingClientRect().top) / e, 0), 1) : 1, r = 0.6, o = 0.4, a = r, c = Math.min(s / r, 1), l = Math.min(
      Math.max((s - o) / (a - o), 0),
      1
    );
    this.style.setProperty("--ftb-p", c.toFixed(4)), this.style.setProperty("--ftb-t", l.toFixed(4));
  }
  onClick(t) {
    const e = Number(t.currentTarget.dataset.kikTab);
    Number.isInteger(e) && this.activate(e);
  }
  onKeydown(t) {
    if (t.key !== "ArrowRight" && t.key !== "ArrowLeft")
      return;
    t.preventDefault();
    const e = this.tabs.indexOf(t.currentTarget), i = t.key === "ArrowRight" ? 1 : -1, s = (e + i + this.tabs.length) % this.tabs.length;
    this.activate(s), this.tabs[s].focus();
  }
  activate(t) {
    this.tabs.forEach((e, i) => {
      const s = i === t;
      e.classList.toggle("is-active", s), e.setAttribute("aria-selected", s ? "true" : "false");
    }), this.panels.forEach((e, i) => {
      const s = i === t;
      e.classList.toggle("is-active", s), s ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", "true"), e.querySelectorAll("video").forEach((r) => {
        if (s) {
          const o = r.play();
          o && typeof o.catch == "function" && o.catch(() => {
          });
        } else
          r.pause();
      });
    }), this.scrollTabIntoView(this.tabs[t]);
  }
  // The tab row scrolls horizontally (scrollbar hidden) when tabs overflow.
  // Center the active tab in the row so it is fully visible and its neighbours
  // peek in, hinting there are more tabs. Only scrolls the row itself — never
  // the page — so the pinned scroll reveal is not disturbed.
  scrollTabIntoView(t) {
    const e = t?.parentElement;
    if (!e || e.scrollWidth <= e.clientWidth)
      return;
    const i = t.getBoundingClientRect().left - e.getBoundingClientRect().left, s = e.scrollLeft + i - (e.clientWidth - t.offsetWidth) / 2, r = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    e.scrollTo({ left: s, behavior: r ? "auto" : "smooth" });
  }
}
customElements.get("kik-tab-banner") || customElements.define("kik-tab-banner", P);
class z extends HTMLElement {
  connectedCallback() {
    this.count = Number(this.dataset.count || 0) || 0, this.count !== 0 && (this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches, this.titles = Array.from(this.querySelectorAll("[data-kik-feature]")), this.panels = Array.from(this.querySelectorAll("[data-kik-panel]")), this.desktopDots = Array.from(this.querySelectorAll("[data-kik-dot]")), this.scroller = this.querySelector(".kik-scf__scroller"), this.stage = this.querySelector(".kik-scf__stage"), this.track = this.querySelector("[data-kik-track]"), this.cards = Array.from(this.querySelectorAll("[data-kik-card]")), this.mobileDots = Array.from(this.querySelectorAll("[data-kik-dot-mobile]")), this.activeIndex = -1, this.ticking = !1, this.scroller && (this.onScroll = this.onScroll.bind(this), window.addEventListener("scroll", this.onScroll, { passive: !0 }), window.addEventListener("resize", this.onScroll, { passive: !0 }), this.titles.forEach((t) => {
      t.addEventListener("click", () => this.jumpTo(Number(t.dataset.kikFeature)));
    }), this.updateFromScroll()), this.track && (this.onTrackScroll = this.onTrackScroll.bind(this), this.track.addEventListener("scroll", this.onTrackScroll, { passive: !0 }), this.setMobile(0)), this.setActive(0));
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScroll), window.removeEventListener("resize", this.onScroll), this.track?.removeEventListener("scroll", this.onTrackScroll);
  }
  onScroll() {
    this.ticking || (this.ticking = !0, requestAnimationFrame(() => {
      this.updateFromScroll(), this.ticking = !1;
    }));
  }
  updateFromScroll() {
    this.syncViewportLayout();
    const t = this.scrollDistance();
    if (t <= 0) {
      this.setActive(0);
      return;
    }
    const e = this.stickyTop() - this.scroller.getBoundingClientRect().top, i = Math.min(Math.max(e / t, 0), 1), s = Math.round(i * (this.count - 1));
    this.setActive(s);
  }
  scrollDistance() {
    return !this.scroller || !this.stage ? 0 : Math.max(0, this.scroller.offsetHeight - this.stage.offsetHeight);
  }
  stickyTop() {
    if (!this.stage)
      return 0;
    const t = Number.parseFloat(window.getComputedStyle(this.stage).top);
    return Number.isFinite(t) ? t : 0;
  }
  syncViewportLayout() {
    if (!this.scroller || !this.stage)
      return;
    if (!window.matchMedia("(min-width: 1025px)").matches) {
      this.style.removeProperty("--kik-scf-sticky-top");
      return;
    }
    let e = 0;
    for (const s of [".kik-header-section", ".cc-kik-sticky-nav"]) {
      const r = document.querySelector(s);
      if (!r)
        continue;
      const o = window.getComputedStyle(r);
      if (o.position !== "sticky" && o.position !== "fixed")
        continue;
      const a = r.getBoundingClientRect(), c = Number.parseFloat(o.top);
      Number.isFinite(c) && a.top <= c + 1 && a.bottom > 0 && a.top < window.innerHeight && (e = Math.max(e, a.bottom));
    }
    const i = Math.max(0, Math.ceil(e));
    this.style.setProperty("--kik-scf-sticky-top", `${i}px`);
  }
  jumpTo(t) {
    if (!this.scroller || !Number.isInteger(t))
      return;
    this.syncViewportLayout();
    const e = this.scrollDistance();
    if (e <= 0)
      return;
    const i = this.count > 1 ? e / (this.count - 1) : 0, r = this.scroller.getBoundingClientRect().top + window.scrollY - this.stickyTop() + i * t;
    window.scrollTo({ top: r, behavior: this.reduceMotion ? "auto" : "smooth" });
  }
  setActive(t) {
    t !== this.activeIndex && (this.activeIndex = t, this.titles.forEach((e, i) => e.classList.toggle("is-active", i === t)), this.desktopDots.forEach((e, i) => e.classList.toggle("is-active", i === t)), this.panels.forEach((e, i) => {
      const s = i === t;
      e.classList.toggle("is-active", s), s ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", "true"), this.toggleVideo(e, s);
    }));
  }
  onTrackScroll() {
    this.ticking || (this.ticking = !0, requestAnimationFrame(() => {
      const t = Math.min(Math.round(this.track.scrollLeft / this.trackStep()), this.count - 1);
      this.setMobile(t), this.ticking = !1;
    }));
  }
  // Distance between two card starts. Measured, not card width + a literal gap:
  // `gap-md` is 8px below 769px but 16px above it, and the carousel now runs up
  // to 1024px, so a hard-coded gap drifts the dot index on tablet widths.
  trackStep() {
    const [t, e] = this.cards;
    return e ? e.offsetLeft - t.offsetLeft || 1 : t && t.offsetWidth || 1;
  }
  setMobile(t) {
    this.mobileDots.forEach((e, i) => e.classList.toggle("is-active", i === t)), this.cards.forEach((e, i) => this.toggleVideo(e, i === t));
  }
  toggleVideo(t, e) {
    t.querySelectorAll("video").forEach((i) => {
      if (e) {
        const s = i.play();
        s && typeof s.catch == "function" && s.catch(() => {
        });
      } else
        i.pause();
    });
  }
}
customElements.get("kik-scroll-features") || customElements.define("kik-scroll-features", z);
class O extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector("[data-kik-cc-track]"), this.slides = Array.from(this.querySelectorAll("[data-kik-cc-slide]")), this.dots = Array.from(this.querySelectorAll("[data-kik-cc-dot]")), this.prev = this.querySelector("[data-kik-cc-prev]"), this.next = this.querySelector("[data-kik-cc-next]"), !(!this.track || this.slides.length === 0) && (this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches, this.index = 0, this.viewport = this.querySelector("[data-kik-cc-viewport]"), this.prev?.addEventListener("click", () => this.move(-1)), this.next?.addEventListener("click", () => this.move(1)), this.dots.forEach((t) => {
      t.addEventListener("click", () => this.goTo(Number(t.dataset.kikCcDot)));
    }), this.viewport ? this.initTransform() : this.initScroll());
  }
  disconnectedCallback() {
    this.onScroll && this.track?.removeEventListener("scroll", this.onScroll), this.onResize && window.removeEventListener("resize", this.onResize), this.endDrag();
  }
  // Nav entry point — routes an absolute index to the active mode (used by dots).
  goTo(t) {
    this.viewport ? this.slideTo(t, !0) : this.scrollToIndex(t);
  }
  // Step one card in either direction (used by the prev/next arrows).
  // Scroll mode derives the starting point from the live scroll position rather
  // than this.index, because syncFromScroll clamps this.index to the last slide
  // as soon as the track nears its end. With several cards per view that clamp
  // fires after a single "next", so stepping from this.index would send "prev"
  // past maxOffset — the scroll would clamp and the track wouldn't move.
  move(t) {
    this.viewport ? this.slideTo(this.index + t, !0) : this.scrollToIndex(this.leadingIndex() + t);
  }
  clampIndex(t) {
    return Math.min(Math.max(t, 0), this.slides.length - 1);
  }
  // ---------------------------------------------------------------------------
  // Transform mode
  // ---------------------------------------------------------------------------
  initTransform() {
    this.offset = 0, this.track.style.willChange = "transform", this.onDown = this.onDown.bind(this), this.onMove = this.onMove.bind(this), this.onUp = this.onUp.bind(this), this.viewport.addEventListener("pointerdown", this.onDown), this.onResize = () => this.slideTo(this.index, !1), window.addEventListener("resize", this.onResize), this.slideTo(0, !1);
  }
  // Furthest the track can travel before the last card sits flush to the right.
  maxOffset() {
    return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
  }
  slideTo(t, e = !0) {
    this.index = this.clampIndex(t);
    const i = Math.min(this.slides[this.index].offsetLeft, this.maxOffset());
    this.setOffset(i, e), this.setActive(this.index);
  }
  setOffset(t, e = !0) {
    this.offset = t, this.track.style.transition = e && !this.reduceMotion ? "transform 400ms ease" : "none", this.track.style.transform = `translateX(${-t}px)`;
  }
  // Index of the slide whose left edge is nearest a given track offset.
  nearestIndex(t) {
    let e = 0, i = 1 / 0;
    return this.slides.forEach((s, r) => {
      const o = Math.abs(s.offsetLeft - t);
      o < i && (i = o, e = r);
    }), e;
  }
  // ---- pointer drag (touch + mouse swipe) ----
  onDown(t) {
    t.button != null && t.button !== 0 || (this.dragging = !0, this.startX = t.clientX, this.startOffset = this.offset, this.pointerId = t.pointerId, this.viewport.setPointerCapture?.(t.pointerId), this.track.style.transition = "none", window.addEventListener("pointermove", this.onMove), window.addEventListener("pointerup", this.onUp), window.addEventListener("pointercancel", this.onUp));
  }
  onMove(t) {
    if (!this.dragging)
      return;
    const e = t.clientX - this.startX, i = Math.min(Math.max(this.startOffset - e, 0), this.maxOffset());
    this.setOffset(i, !1);
  }
  onUp() {
    this.dragging && (this.endDrag(), this.slideTo(this.nearestIndex(this.offset), !0));
  }
  endDrag() {
    this.dragging && (this.dragging = !1, this.pointerId != null && this.viewport?.releasePointerCapture?.(this.pointerId), window.removeEventListener("pointermove", this.onMove), window.removeEventListener("pointerup", this.onUp), window.removeEventListener("pointercancel", this.onUp));
  }
  // ---------------------------------------------------------------------------
  // Scroll mode (native scroll-snap fallback)
  // ---------------------------------------------------------------------------
  initScroll() {
    this.ticking = !1, this.onScroll = this.onScroll.bind(this), this.track.addEventListener("scroll", this.onScroll, { passive: !0 }), this.syncFromScroll();
  }
  scrollToIndex(t) {
    const e = this.clampIndex(t), i = this.slides[e];
    if (!i)
      return;
    const s = i.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
    this.track.scrollTo({ left: this.track.scrollLeft + s, behavior: this.reduceMotion ? "auto" : "smooth" });
  }
  onScroll() {
    this.ticking || (this.ticking = !0, requestAnimationFrame(() => {
      this.syncFromScroll(), this.ticking = !1;
    }));
  }
  syncFromScroll() {
    if (this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2) {
      this.setActive(this.slides.length - 1);
      return;
    }
    this.setActive(this.leadingIndex());
  }
  // Index of the slide whose left edge is nearest the track's left edge, based
  // on the live scroll position (unlike this.index, which setActive can clamp
  // to the last slide when the track is scrolled to its end).
  leadingIndex() {
    const t = this.track.getBoundingClientRect().left;
    let e = 0, i = 1 / 0;
    return this.slides.forEach((s, r) => {
      const o = Math.abs(s.getBoundingClientRect().left - t);
      o < i && (i = o, e = r);
    }), e;
  }
  // ---------------------------------------------------------------------------
  // Shared
  // ---------------------------------------------------------------------------
  setActive(t) {
    this.index = t, this.dots.forEach((e, i) => {
      const s = i === t;
      e.classList.toggle("is-active", s), e.setAttribute("aria-current", s ? "true" : "false");
    }), this.prev && (this.prev.disabled = t <= 0), this.next && (this.next.disabled = t >= this.slides.length - 1);
  }
}
customElements.get("kik-card-carousel") || customElements.define("kik-card-carousel", O);
class B extends HTMLElement {
  connectedCallback() {
    this.bgs = Array.from(this.querySelectorAll("[data-kik-hc-bg]")), this.cards = Array.from(this.querySelectorAll("[data-kik-hc-card]")), this.captions = Array.from(this.querySelectorAll("[data-kik-hc-caption]")), this.dots = Array.from(this.querySelectorAll("[data-kik-hc-dot]")), this.count = this.bgs.length || Number(this.dataset.count) || 0, this.count !== 0 && (this.index = 0, this.cards.forEach((t, e) => {
      t.addEventListener("mouseenter", () => this.setActive(e)), t.addEventListener("focusin", () => this.setActive(e)), t.addEventListener("click", () => this.setActive(e));
    }), this.dots.forEach((t, e) => {
      t.addEventListener("click", () => {
        this.setActive(e), this.pauseAutoplay();
      });
    }), this.touchX = null, this.addEventListener("touchstart", (t) => {
      this.touchX = t.touches[0].clientX;
    }, { passive: !0 }), this.addEventListener("touchend", (t) => {
      if (this.touchX === null) return;
      const e = t.changedTouches[0].clientX - this.touchX;
      this.touchX = null, !(Math.abs(e) < 40) && (this.setActive(e < 0 ? this.index + 1 : this.index - 1), this.pauseAutoplay());
    }, { passive: !0 }), this.setActive(0), this.startAutoplay());
  }
  disconnectedCallback() {
    this.pauseAutoplay();
  }
  startAutoplay() {
    const t = Number(this.dataset.autoplay) || 0;
    t <= 0 || this.count < 2 || window.matchMedia("(prefers-reduced-motion: reduce)").matches || (this.autoplayMs = t * 1e3, this.timer = window.setInterval(() => {
      window.matchMedia("(min-width: 769px)").matches || this.setActive(this.index + 1);
    }, this.autoplayMs));
  }
  pauseAutoplay() {
    this.timer && (window.clearInterval(this.timer), this.timer = null);
  }
  setActive(t) {
    const e = (t % this.count + this.count) % this.count;
    this.index = e, this.toggle(this.bgs, e), this.toggle(this.captions, e, !0), this.dots.forEach((i, s) => {
      const r = s === e;
      i.classList.toggle("is-active", r), i.setAttribute("aria-current", r ? "true" : "false");
    }), this.cards.forEach((i, s) => {
      const r = s === e;
      i.classList.toggle("is-active", r), i.setAttribute("aria-expanded", r ? "true" : "false");
    });
  }
  toggle(t, e, i) {
    t.forEach((s, r) => {
      const o = r === e;
      s.classList.toggle("is-active", o), i && s.setAttribute("aria-hidden", o ? "false" : "true");
    });
  }
}
customElements.get("kik-hover-cards") || customElements.define("kik-hover-cards", B);
class F extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector(".khs__track"), this.stage = this.querySelector(".khs__stage"), this.cards = Array.from(this.querySelectorAll("[data-kik-khs-card]")), this.mcards = Array.from(this.querySelectorAll("[data-kik-khs-mcard]")), this.hotspots = Array.from(this.querySelectorAll("[data-kik-khs-hotspot]")), this.dots = Array.from(this.querySelectorAll("[data-kik-khs-dot]")), this.count = Number(this.dataset.count) || this.cards.length || this.mcards.length, !(!this.track || this.count === 0) && (this.index = -1, this.onScroll = this.onScroll.bind(this), this.ticking = !1, window.addEventListener("scroll", this.onScroll, { passive: !0 }), window.addEventListener("resize", this.onScroll, { passive: !0 }), this.resizeObserver = new ResizeObserver(this.onScroll), this.resizeObserver.observe(this.stage), this.dots.forEach((t, e) => t.addEventListener("click", () => this.scrollToStep(e))), this.hotspots.forEach((t, e) => {
      t.style.pointerEvents = "auto", t.style.cursor = "pointer", t.addEventListener("click", () => this.scrollToStep(e));
    }), this.update());
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScroll), window.removeEventListener("resize", this.onScroll), this.resizeObserver?.disconnect();
  }
  onScroll() {
    this.ticking || (this.ticking = !0, requestAnimationFrame(() => {
      this.update(), this.ticking = !1;
    }));
  }
  // Fraction of the track scrolled through, 0..1, while it is pinned.
  progress() {
    const t = this.scrollDistance();
    if (t <= 0)
      return 0;
    const e = this.stickyTop() - this.track.getBoundingClientRect().top;
    return Math.min(Math.max(e / t, 0), 1);
  }
  update() {
    this.syncViewportLayout();
    const t = Math.min(Math.floor(this.progress() * this.count), this.count - 1);
    t !== this.index && this.setActive(t);
  }
  syncViewportLayout() {
    if (!this.track || !this.stage)
      return;
    let t = 0;
    for (const r of [".kik-header-section", ".cc-kik-sticky-nav"]) {
      const o = document.querySelector(r);
      if (!o)
        continue;
      const a = window.getComputedStyle(o);
      if (a.position !== "sticky" && a.position !== "fixed")
        continue;
      const c = o.getBoundingClientRect(), l = Number.parseFloat(a.top);
      Number.isFinite(l) && c.top <= l + 1 && c.bottom > 0 && c.top < window.innerHeight && (t = Math.max(t, c.bottom));
    }
    const e = Number.parseFloat(window.getComputedStyle(this).getPropertyValue("--khs-sticky-gap")) || 0, i = Math.min(
      Math.max(0, Math.ceil(t)) + e,
      window.innerHeight - this.stage.offsetHeight
    );
    this.style.setProperty("--khs-stage-top", `${i}px`);
    const s = Math.max(0, t + e - Math.max(this.stage.getBoundingClientRect().top, i));
    this.style.setProperty("--khs-panel-safe-top", `${s}px`);
  }
  scrollDistance() {
    return !this.track || !this.stage ? 0 : Math.max(0, this.track.offsetHeight - this.stage.offsetHeight);
  }
  stickyTop() {
    if (!this.stage)
      return 0;
    const t = Number.parseFloat(window.getComputedStyle(this.stage).top);
    return Number.isFinite(t) ? t : 0;
  }
  scrollToStep(t) {
    this.syncViewportLayout();
    const e = this.track.getBoundingClientRect(), i = this.scrollDistance(), r = window.scrollY + e.top - this.stickyTop() + i * ((t + 0.5) / this.count), o = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: r, behavior: o ? "auto" : "smooth" });
  }
  setActive(t) {
    this.index = t, this.toggle(this.cards, t), this.toggle(this.hotspots, t), this.mcards.forEach((e, i) => {
      const s = i === t;
      e.classList.toggle("is-active", s), e.setAttribute("aria-hidden", s ? "false" : "true");
    }), this.dots.forEach((e, i) => {
      const s = i === t;
      e.classList.toggle("is-active", s), e.setAttribute("aria-current", s ? "true" : "false");
    });
  }
  toggle(t, e) {
    t.forEach((i, s) => i.classList.toggle("is-active", s === e));
  }
}
customElements.get("kik-hotspot-scroll") || customElements.define("kik-hotspot-scroll", F);
class V extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll("[data-kik-cc-slide]")), this.slides.forEach((t) => this.wireVideo(t));
  }
  wireVideo(t) {
    const e = t.querySelector("[data-kik-cc-video]"), i = t.querySelector("[data-kik-cc-play]");
    if (!e)
      return;
    const s = (o) => {
      i && (i.style.opacity = o ? "1" : "0", i.style.pointerEvents = o ? "auto" : "none");
    }, r = () => {
      e.paused ? (e.muted = !1, e.play().then(() => s(!1)).catch(() => {
      })) : (e.pause(), s(!0));
    };
    i?.addEventListener("click", (o) => {
      o.preventDefault(), o.stopPropagation(), r();
    }), e.addEventListener("click", r), e.addEventListener("ended", () => s(!0));
  }
}
customElements.get("kik-creator-carousel") || customElements.define("kik-creator-carousel", V);
class N extends HTMLElement {
  connectedCallback() {
    if (this.track = this.querySelector("[data-kik-cs-track]"), this.slides = Array.from(this.querySelectorAll("[data-kik-cs-slide]")), !this.track || this.slides.length === 0)
      return;
    const t = this.closest(".kik-compare-slider") || this;
    this.dots = Array.from(t.querySelectorAll("[data-kik-cs-dot]")), this.prevs = Array.from(t.querySelectorAll("[data-kik-cs-prev]")), this.nexts = Array.from(t.querySelectorAll("[data-kik-cs-next]")), this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches, this.index = 0, this.ticking = !1, this.onScroll = this.onScroll.bind(this), this.track.addEventListener("scroll", this.onScroll, { passive: !0 }), this.prevs.forEach((e) => e.addEventListener("click", () => this.scrollToIndex(this.index - 1))), this.nexts.forEach((e) => e.addEventListener("click", () => this.scrollToIndex(this.index + 1))), this.dots.forEach((e) => e.addEventListener("click", () => this.scrollToIndex(Number(e.dataset.kikCsDot)))), this.syncFromScroll();
  }
  disconnectedCallback() {
    this.track?.removeEventListener("scroll", this.onScroll);
  }
  step() {
    return this.track.clientWidth || 1;
  }
  scrollToIndex(t) {
    const e = Math.min(Math.max(t, 0), this.slides.length - 1);
    this.track.scrollTo({ left: e * this.step(), behavior: this.reduceMotion ? "auto" : "smooth" });
  }
  onScroll() {
    this.ticking || (this.ticking = !0, requestAnimationFrame(() => {
      this.syncFromScroll(), this.ticking = !1;
    }));
  }
  syncFromScroll() {
    const t = Math.min(Math.round(this.track.scrollLeft / this.step()), this.slides.length - 1);
    this.setActive(t);
  }
  setActive(t) {
    this.index = t, this.dots.forEach((e, i) => {
      const s = i === t;
      e.classList.toggle("is-active", s), e.setAttribute("aria-current", s ? "true" : "false");
    });
  }
}
customElements.get("kik-compare-slider") || customElements.define("kik-compare-slider", N);
class y extends HTMLElement {
  // Category pill reorder — matches the accordion's 350ms answer transition.
  static REORDER_MS = 350;
  connectedCallback() {
    this.cats = Array.from(this.querySelectorAll("[data-kik-faq-cat]")), this.panels = Array.from(this.querySelectorAll("[data-kik-faq-panel]")), this.cats.forEach((t, e) => {
      t.addEventListener("click", () => this.selectCategory(e));
    }), this.querySelectorAll("[data-kik-faq-item]").forEach((t) => {
      t.querySelector("[data-kik-faq-q]")?.addEventListener("click", () => this.toggleItem(t));
    });
  }
  selectCategory(t) {
    this.cats.forEach((e, i) => {
      const s = i === t;
      e.classList.toggle("is-active", s), e.setAttribute("aria-selected", s ? "true" : "false");
    }), this.panels.forEach((e, i) => {
      const s = i === t;
      e.classList.toggle("hidden", !s), s && Array.from(e.querySelectorAll("[data-kik-faq-item]")).forEach((o, a) => this.setOpen(o, a === 0));
    }), this.reorderCats(t);
  }
  // On mobile the category row is a horizontal scroller. Rotate the pills via
  // CSS `order` so the clicked one becomes visually first (e.g. clicking pill 2
  // of [1,2,3,4] yields [2,3,4,1]), then reset scroll to the left edge. Desktop
  // stacks vertically — reordering would be jarring there, so we skip it.
  //
  // Both `order` and `scrollLeft` jump, so the move is animated with FLIP:
  // measure where every pill is, apply the new layout, then transform each pill
  // back to where it was and let it slide home. Pills that wrap from the front
  // to the back of the row fade in at their new spot rather than flying across.
  reorderCats(t) {
    const e = this.cats[t], i = e?.parentElement;
    if (!i) return;
    const s = this.cats.length;
    if (s === 0) return;
    if (!(i.scrollWidth > i.clientWidth)) {
      this.cats.forEach((l) => {
        l.style.order = "";
      });
      return;
    }
    const o = typeof e.animate == "function" && !window.matchMedia?.("(prefers-reduced-motion: reduce)").matches, a = o ? this.cats.map((l) => l.getBoundingClientRect().left) : null;
    if (this.cats.forEach((l, h) => {
      l.style.order = String((h - t + s) % s);
    }), i.scrollLeft = 0, !o) return;
    const c = this.cats.map((l) => l.getBoundingClientRect().left);
    this.cats.forEach((l, h) => {
      const d = { duration: y.REORDER_MS, easing: "cubic-bezier(0.4, 0, 0.2, 1)" };
      if (h < t) {
        l.animate([{ opacity: 0 }, { opacity: 1 }], d);
        return;
      }
      const m = a[h] - c[h];
      m && l.animate(
        [{ transform: `translateX(${m}px)` }, { transform: "translateX(0)" }],
        d
      );
    });
  }
  toggleItem(t) {
    const e = !t.classList.contains("is-open"), i = t.closest("[data-kik-faq-panel]");
    i && e && i.querySelectorAll("[data-kik-faq-item]").forEach((s) => {
      s !== t && this.setOpen(s, !1);
    }), this.setOpen(t, e);
  }
  setOpen(t, e) {
    t.classList.toggle("is-open", e), t.querySelector("[data-kik-faq-q]")?.setAttribute("aria-expanded", e ? "true" : "false");
  }
}
customElements.get("kik-faq") || customElements.define("kik-faq", y);
var Y = class extends HTMLElement {
  connectedCallback() {
    if (this.tabs = Array.from(this.querySelectorAll("[data-kik-mc-tab]")), this.panels = Array.from(this.querySelectorAll("[data-kik-mc-panel]")), this.track = this.querySelector("[data-kik-mc-track]"), this.viewport = this.querySelector("[data-kik-mc-viewport]"), this.prevBtn = this.querySelector("[data-kik-mc-prev]"), this.nextBtn = this.querySelector("[data-kik-mc-next]"), this.nav = this.querySelector(".kik-mc-nav"), this.logoViewport = this.querySelector("[data-kik-mc-logos]"), this.logoTrack = this.querySelector("[data-kik-mc-logo-track]"), this.logoGroup = this.querySelector("[data-kik-mc-logo-group]"), !(this.panels.length < 2)) {
      if (this.index = 0, this.hovered = !1, this.focused = !1, this.dragging = !1, this.logoDragMoved = !1, this.desktopPreference = window.matchMedia("(min-width: 769px)"), this.motionPreference = window.matchMedia("(prefers-reduced-motion: reduce)"), this.onMouseEnter = () => {
        this.hovered = !0, this.scheduleRotation();
      }, this.onMouseLeave = () => {
        this.hovered = !1, this.scheduleRotation();
      }, this.onFocusIn = (n) => {
        this.focused = !0, this.logoAnimation && this.logoViewport.contains(n.target) && (this.logoAnimation.currentTime = 0), this.scheduleRotation();
      }, this.onFocusOut = (n) => {
        this.focused = this.contains(n.relatedTarget), this.scheduleRotation();
      }, this.onVisibilityChange = () => this.scheduleRotation(), this.onMotionChange = () => this.scheduleRotation(), this.onDesktopChange = () => this.buildMarquee(), this.addOrRemoveRotationListeners("addEventListener"), this.onTabClick = (n) => {
        if (this.shouldSuppressLogoClick(n)) {
          n.preventDefault();
          return;
        }
        this.activate(Number(n.currentTarget.dataset.kikMcTab));
      }, this.onTabKeydown = (n) => {
        let t = n.key === "ArrowRight" ? 1 : n.key === "ArrowLeft" ? -1 : 0;
        if (!t) return;
        n.preventDefault();
        let e = (this.index + t + this.tabs.length) % this.tabs.length;
        this.activate(e), this.tabs[e]?.focus();
      }, this.onLogoClick = (n) => {
        if (this.shouldSuppressLogoClick(n)) {
          n.preventDefault();
          return;
        }
        const t = n.target.closest("[data-kik-mc-tab]");
        if (!this.tabs.includes(t) && t && this.logoTrack.contains(t)) {
          const e = Number(t.dataset.kikMcTab);
          this.activate(e), this.tabs[e]?.focus({ preventScroll: !0 });
        }
      }, this.logoTrack?.addEventListener("click", this.onLogoClick), this.onLogoPointerDown = (n) => this.startLogoDrag(n), this.onLogoPointerMove = (n) => this.moveLogoDrag(n), this.onLogoPointerUp = (n) => this.endLogoDrag(n), this.logoViewport?.addEventListener("pointerdown", this.onLogoPointerDown), this.logoViewport?.addEventListener("pointermove", this.onLogoPointerMove), this.logoViewport?.addEventListener("pointerup", this.onLogoPointerUp), this.logoViewport?.addEventListener("pointercancel", this.onLogoPointerUp), this.tabs.forEach((n) => {
        n.addEventListener("click", this.onTabClick), n.addEventListener("keydown", this.onTabKeydown);
      }), this.onPrev = () => this.activate((this.index - 1 + this.panels.length) % this.panels.length), this.onNext = () => this.activate((this.index + 1) % this.panels.length), this.prevBtn?.addEventListener("click", this.onPrev), this.nextBtn?.addEventListener("click", this.onNext), this.viewport) {
        let n = 0;
        this.onTouchStart = (t) => {
          n = t.changedTouches[0].clientX;
        }, this.onTouchEnd = (t) => {
          let e = t.changedTouches[0].clientX - n;
          if (Math.abs(e) < 40) return;
          let i = e < 0 ? 1 : -1, s = (this.index + i + this.panels.length) % this.panels.length;
          this.activate(s);
        }, this.viewport.addEventListener("touchstart", this.onTouchStart, { passive: !0 }), this.viewport.addEventListener("touchend", this.onTouchEnd, { passive: !0 });
      }
      this.activate(0), this.nav && (this.arrowResizeObserver = new ResizeObserver(() => this.positionArrows()), this.arrowResizeObserver.observe(this.nav), this.panels.forEach((n) => {
        const t = n.querySelector("[data-kik-mc-image]");
        t && this.arrowResizeObserver.observe(t);
      }), this.positionArrows()), this.logoGroup && this.logoTrack && this.logoViewport && (this.logoResizeObserver = new ResizeObserver(() => this.buildMarquee()), this.logoResizeObserver.observe(this.logoViewport), this.logoResizeObserver.observe(this.logoGroup), this.buildMarquee());
    }
  }
  disconnectedCallback() {
    this.logoResizeObserver?.disconnect(), this.arrowResizeObserver?.disconnect(), this.logoAnimation?.cancel(), this.repeatWidth = null, this.repeatCopies = null, this.logoTrack?.removeEventListener("click", this.onLogoClick), this.logoViewport?.removeEventListener("pointerdown", this.onLogoPointerDown), this.logoViewport?.removeEventListener("pointermove", this.onLogoPointerMove), this.logoViewport?.removeEventListener("pointerup", this.onLogoPointerUp), this.logoViewport?.removeEventListener("pointercancel", this.onLogoPointerUp), this.logoTrack?.querySelectorAll("[data-kik-mc-clone]").forEach((n) => n.remove()), this.addOrRemoveRotationListeners("removeEventListener"), this.tabs?.forEach((n) => {
      n.removeEventListener("click", this.onTabClick), n.removeEventListener("keydown", this.onTabKeydown);
    }), this.prevBtn?.removeEventListener("click", this.onPrev), this.nextBtn?.removeEventListener("click", this.onNext), this.viewport && (this.viewport.removeEventListener("touchstart", this.onTouchStart), this.viewport.removeEventListener("touchend", this.onTouchEnd));
  }
  startLogoDrag(n) {
    !this.logoViewport || n.button !== void 0 && n.button !== 0 || (this.dragging = !0, this.logoDragMoved = !1, this.logoDragStartX = n.clientX, this.logoDragStartScrollLeft = this.logoViewport.scrollLeft, this.logoPointerDownTab = n.target?.closest?.("[data-kik-mc-tab]") || null, this.logoViewport.setPointerCapture?.(n.pointerId), this.scheduleRotation());
  }
  moveLogoDrag(n) {
    if (!this.dragging || !this.logoViewport) return;
    const t = n.clientX - this.logoDragStartX;
    Math.abs(t) < 3 || (this.logoViewport.scrollLeft = this.logoDragStartScrollLeft - t, Math.abs(this.logoViewport.scrollLeft - this.logoDragStartScrollLeft) < 3) || (this.logoDragMoved = !0, n.preventDefault());
  }
  endLogoDrag(n) {
    if (!this.dragging || !this.logoViewport) return;
    const t = Number.isFinite(n.clientX) ? Math.abs(n.clientX - this.logoDragStartX) : Number.POSITIVE_INFINITY, e = Math.abs(this.logoViewport.scrollLeft - this.logoDragStartScrollLeft);
    if (this.logoDragMoved = this.logoDragMoved && t >= 3 && e >= 3, t < 3 && this.logoPointerDownTab) {
      const i = Number(this.logoPointerDownTab.dataset.kikMcTab);
      this.activate(i);
    }
    this.logoPointerDownTab = null, this.dragging = !1, this.logoViewport.releasePointerCapture?.(n.pointerId), this.scheduleRotation();
  }
  shouldSuppressLogoClick(n) {
    return !this.logoDragMoved || n.detail === 0 ? !1 : !Number.isFinite(n.clientX) || !Number.isFinite(this.logoDragStartX) ? !0 : Math.abs(n.clientX - this.logoDragStartX) >= 3;
  }
  positionArrows() {
    const n = this.panels?.[this.index]?.querySelector("[data-kik-mc-image]");
    if (!this.nav || !n) return;
    const t = this.nav.getBoundingClientRect(), e = n.getBoundingClientRect();
    if (!e.height) return;
    const i = e.top - t.top + e.height / 2;
    this.nav.style.setProperty("--kik-mc-arrow-top", `${i}px`);
  }
  addOrRemoveRotationListeners(n) {
    this[n]("mouseenter", this.onMouseEnter), this[n]("mouseleave", this.onMouseLeave), this[n]("focusin", this.onFocusIn), this[n]("focusout", this.onFocusOut), document[n]("visibilitychange", this.onVisibilityChange), this.desktopPreference?.[n]("change", this.onDesktopChange), this.motionPreference?.[n]("change", this.onMotionChange);
  }
  scheduleRotation() {
    this.logoAnimation && (this.motionPreference?.matches && (this.logoAnimation.currentTime = 0), !this.isConnected || this.hovered || this.focused || this.dragging || document.hidden || this.motionPreference?.matches ? this.logoAnimation.pause() : (this.logoViewport.scrollLeft = 0, this.logoAnimation.play()));
  }
  buildMarquee() {
    const n = this.tabs.length > 5 && this.desktopPreference?.matches;
    if (this.dataset.kikMcMarquee = n ? "true" : "false", !n) {
      this.logoAnimation?.cancel(), this.logoAnimation = null, this.logoTrack.querySelectorAll("[data-kik-mc-clone]").forEach((o) => o.remove()), this.logoGroup.style.paddingRight = "", this.repeatWidth = null, this.repeatCopies = null;
      return;
    }
    this.logoGroup.style.paddingRight = getComputedStyle(this.logoGroup).columnGap;
    const t = this.logoGroup.getBoundingClientRect().width, e = this.logoViewport.clientWidth;
    if (!t || !e) return;
    const i = Math.max(2, Math.ceil(e / t) + 1);
    if (this.repeatWidth === t && this.repeatCopies === i) return;
    const s = this.repeatWidth && this.logoAnimation ? Number(this.logoAnimation.currentTime) / (this.repeatWidth / 32 * 1e3) % 1 : 0;
    this.logoAnimation?.cancel(), this.logoTrack.querySelectorAll("[data-kik-mc-clone]").forEach((o) => o.remove());
    for (let o = 1; o < i; o++) {
      const a = this.logoGroup.cloneNode(!0);
      a.setAttribute("data-kik-mc-clone", ""), a.setAttribute("aria-hidden", "true"), a.removeAttribute("role"), a.removeAttribute("data-kik-mc-logo-group"), a.removeAttribute("data-kik-region"), a.querySelectorAll("[id]").forEach((c) => c.removeAttribute("id")), a.querySelectorAll("[data-kik-mc-tab]").forEach((c) => {
        c.setAttribute("tabindex", "-1"), c.removeAttribute("role"), c.removeAttribute("aria-controls"), c.removeAttribute("aria-selected"), c.removeAttribute("data-shopify-editor-block");
      }), this.logoTrack.append(a);
    }
    this.repeatWidth = t, this.repeatCopies = i;
    const r = t / 32 * 1e3;
    this.logoAnimation = this.logoTrack.animate(
      [{ transform: "translateX(0)" }, { transform: `translateX(-${t}px)` }],
      { duration: r, iterations: 1 / 0, easing: "linear" }
    ), this.logoAnimation.currentTime = s * r, this.scheduleRotation();
  }
  activate(n) {
    !Number.isInteger(n) || n < 0 || n >= this.panels.length || (this.index = n, this.track && (this.track.style.transform = "translateX(-" + n * 100 + "%)"), this.panels.forEach((t, e) => {
      let i = e === n;
      this.track || (t.hidden = !i), t.setAttribute("aria-hidden", i ? "false" : "true");
    }), this.tabs.forEach((t, e) => {
      let i = e === n;
      t.setAttribute("aria-selected", i ? "true" : "false"), t.setAttribute("tabindex", i ? "0" : "-1"), t.dataset.kikActive = i ? "true" : "false";
    }), this.logoTrack?.querySelectorAll("[data-kik-mc-clone] [data-kik-mc-tab]").forEach((t) => {
      t.dataset.kikActive = String(Number(t.dataset.kikMcTab) === n);
    }), this.scrollActiveTabIntoView(n), this.positionArrows(), this.scheduleRotation());
  }
  // On mobile the tablist is a horizontal scroller; when the active tab is
  // clipped (e.g. the last logo after swiping to the last panel), scroll the
  // tablist so the highlight is visible. Never scrolls the page vertically.
  scrollActiveTabIntoView(n) {
    let t = this.tabs[n], e = this.logoViewport || t?.parentElement;
    if (!t || !e || this.logoAnimation && !this.focused && !this.motionPreference?.matches || e.scrollWidth <= e.clientWidth) return;
    let i = t.getBoundingClientRect(), s = e.getBoundingClientRect();
    if (i.left >= s.left && i.right <= s.right) return;
    let r = e.scrollLeft + i.left - s.left - (s.width - i.width) / 2;
    e.scrollTo({ left: Math.max(0, r), behavior: this.motionPreference?.matches ? "instant" : "smooth" });
  }
};
customElements.get("kik-media-coverage") || customElements.define("kik-media-coverage", Y);
const L = (n) => {
  try {
    return new Intl.NumberFormat(document.documentElement.lang || "en", {
      style: "currency",
      currency: window.Shopify?.currency?.active || "USD"
    }).format(n / 100);
  } catch {
    return "$" + (n / 100).toFixed(2);
  }
};
class K extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector("[data-kik-product-form], form"), this.variantIdInput = this.querySelector("[data-kik-variant-id]"), this.variants = this.readVariants(), this.wireGallery(), this.wireLightbox(), this.wireVideo(), this.wireQuantity(), this.wireVariants(), this.wirePopups(), this.wireUpsell(), this.wireCoupon();
  }
  readVariants() {
    const e = (this.closest("section") || document).querySelector("[data-kik-variant-json]");
    if (!e) return [];
    try {
      return JSON.parse(e.textContent) || [];
    } catch {
      return [];
    }
  }
  // ---- Media gallery + thumbnails ----
  wireGallery() {
    this.stages = Array.from(this.querySelectorAll("[data-kik-stage]")), this.thumbs = Array.from(this.querySelectorAll("[data-kik-thumb]")), this.thumbs.forEach(
      (t) => t.addEventListener("click", () => this.showStage(Number(t.dataset.kikThumb)))
    );
  }
  showStage(t) {
    this.stages.forEach((e) => e.classList.toggle("hidden", Number(e.dataset.kikStage) !== t)), this.thumbs.forEach((e) => {
      const i = Number(e.dataset.kikThumb) === t;
      e.classList.toggle("border-border-default", i), e.classList.toggle("border-transparent", !i);
    });
  }
  // ---- Click-to-zoom lightbox (transparent backdrop) ----
  wireLightbox() {
    this.lightbox = this.querySelector("[data-kik-lightbox]"), this.lightboxImg = this.querySelector("[data-kik-lightbox-img]"), this.lightbox && (this.stages.forEach((t) => {
      t.addEventListener("click", () => {
        if (t.dataset.kikHasVideo === "true") return;
        const e = t.dataset.kikZoomSrc;
        e && (this.lightboxImg.src = e, this.openDialog(this.lightbox));
      });
    }), this.querySelector("[data-kik-lightbox-close]")?.addEventListener("click", () => this.closeDialog(this.lightbox)), this.lightbox.addEventListener("click", (t) => {
      t.target === this.lightbox && this.closeDialog(this.lightbox);
    }));
  }
  // ---- Video pop-up ----
  wireVideo() {
    this.videobox = this.querySelector("[data-kik-videobox]"), this.videoMount = this.querySelector("[data-kik-video-mount]");
    const t = this.querySelector("[data-kik-video-embed]");
    if (!this.videobox || !t) return;
    this.stages.forEach((i) => {
      i.dataset.kikHasVideo === "true" && i.addEventListener("click", () => {
        this.videoMount.innerHTML = "", this.videoMount.appendChild(t.content.cloneNode(!0)), this.openDialog(this.videobox);
      });
    });
    const e = () => {
      this.videoMount.innerHTML = "", this.closeDialog(this.videobox);
    };
    this.querySelector("[data-kik-video-close]")?.addEventListener("click", e), this.videobox.addEventListener("click", (i) => {
      i.target === this.videobox && e();
    }), this.videobox.addEventListener("close", () => this.videoMount.innerHTML = "");
  }
  // ---- Quantity stepper ----
  wireQuantity() {
    const t = this.querySelector("[data-kik-qty-input]");
    if (!t) return;
    const e = () => {
      const i = Number(t.min || 1);
      t.value = Math.max(i, Number(t.value) || i);
    };
    this.querySelector("[data-kik-qty-minus]")?.addEventListener("click", () => {
      t.value = Math.max(Number(t.min || 1), (Number(t.value) || 1) - 1);
    }), this.querySelector("[data-kik-qty-plus]")?.addEventListener("click", () => {
      t.value = (Number(t.value) || 1) + 1;
    }), t.addEventListener("change", e);
  }
  // ---- Native variant selection ----
  wireVariants() {
    this.optionInputs = Array.from(this.querySelectorAll("[data-kik-option-input]")), !(this.optionInputs.length === 0 || this.variants.length === 0) && this.optionInputs.forEach((t) => t.addEventListener("change", () => this.onVariantChange()));
  }
  selectedOptions() {
    const t = {};
    return this.optionInputs.forEach((e) => {
      e.checked && (t[e.dataset.optionPosition] = e.value);
    }), t;
  }
  onVariantChange() {
    const t = this.selectedOptions(), e = this.variants.find(
      (a) => [a.option1, a.option2, a.option3].every((c, l) => {
        const h = String(l + 1);
        return t[h] === void 0 || t[h] === c;
      })
    );
    if (this.querySelectorAll("[data-kik-option-index]").forEach((a) => {
      const c = a.querySelector("[data-kik-option-input]:checked"), l = a.querySelector("[data-kik-option-value]");
      c && l && (l.textContent = c.value);
    }), !e) return;
    this.variantIdInput && (this.variantIdInput.value = e.id);
    const i = this.querySelector("[data-kik-price-current]");
    i && (i.textContent = L(e.price)), this.querySelector("kik-payment-options")?.updateAmount(e.price);
    const s = this.querySelector("[data-kik-price-compare]");
    s && (e.compare_at_price && e.compare_at_price > e.price ? (s.textContent = L(e.compare_at_price), s.hidden = !1) : s.hidden = !0);
    const r = this.querySelector("[data-kik-atc]"), o = this.querySelector("[data-kik-atc-text]");
    r && (r.disabled = !e.available, o && (o.textContent = e.available ? r.dataset.availableText || o.textContent : "Sold out"));
  }
  // ---- Policy pop-ups ----
  wirePopups() {
    this.querySelectorAll("[data-kik-popup-open]").forEach((t) => {
      const e = t.dataset.kikPopupOpen, i = this.querySelector(`[data-kik-popup="${e}"]`);
      i && (t.addEventListener("click", () => this.openDialog(i)), i.querySelector("[data-kik-popup-close]")?.addEventListener("click", () => this.closeDialog(i)), i.addEventListener("click", (s) => {
        s.target === i && this.closeDialog(i);
      }));
    });
  }
  // ---- Upsell expansion ----
  wireUpsell() {
    const t = this.querySelector("[data-kik-upsell-more]"), e = Array.from(this.querySelectorAll("[data-kik-upsell-extra]"));
    t?.addEventListener("click", () => {
      const i = t.getAttribute("aria-expanded") !== "true";
      e.forEach((s) => s.hidden = !i), t.setAttribute("aria-expanded", String(i)), t.textContent = i ? t.dataset.lessLabel : t.dataset.moreLabel;
    });
  }
  // ---- Coupon copy ----
  // Uses the async Clipboard API when available (needs HTTPS / secure context),
  // otherwise falls back to a hidden-textarea + document.execCommand('copy').
  // Safari/iOS and older Firefox reject navigator.clipboard.writeText silently,
  // so we always keep the execCommand fallback ready. The button always shows
  // a "Copied!" or "Copy failed" state so users know something happened.
  //
  // Listener is delegated onto <kik-product-main> so it survives the variant-
  // swap re-render — Focal's variant-picker.js replaces the innerHTML of the
  // countdown block's data-dynamic-variant-content wrapper on variant change,
  // which would destroy any listener bound directly to the button.
  wireCoupon() {
    this.addEventListener("click", (t) => {
      const e = t.target.closest("[data-kik-copy-coupon]");
      if (!e || !this.contains(e)) return;
      const s = (e.closest("[data-dynamic-variant-content]") || this).querySelector("[data-kik-coupon]") || this.querySelector("[data-kik-coupon]");
      if (!s) return;
      const r = (s.textContent || "").trim();
      if (!r) return;
      const o = e.textContent, a = (c) => {
        e.textContent = c ? "Copied!" : "Copy failed", setTimeout(() => {
          e.textContent = o;
        }, 1500);
      };
      this._copyToClipboard(r).then(a, () => a(!1));
    });
  }
  _copyToClipboard(t) {
    return navigator.clipboard && window.isSecureContext ? navigator.clipboard.writeText(t).then(() => !0).catch(() => this._fallbackCopy(t)) : Promise.resolve(this._fallbackCopy(t));
  }
  // Legacy path — works in every browser that supports document.execCommand('copy')
  // as long as we're inside a user-gesture handler. Notably: Safari, iOS Safari,
  // and any HTTP context where the async Clipboard API is blocked.
  _fallbackCopy(t) {
    const e = document.createElement("textarea");
    if (e.value = t, e.setAttribute("readonly", ""), e.style.cssText = "position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:0;outline:0;background:transparent;opacity:0;", document.body.appendChild(e), /iP(hone|ad|od)/.test(navigator.userAgent)) {
      e.contentEditable = "true";
      const r = document.createRange();
      r.selectNodeContents(e);
      const o = window.getSelection();
      o.removeAllRanges(), o.addRange(r), e.setSelectionRange(0, t.length);
    } else
      e.select(), e.setSelectionRange(0, t.length);
    let s = !1;
    try {
      s = document.execCommand("copy");
    } catch {
    }
    return document.body.removeChild(e), s;
  }
  // ---- <dialog> helpers (graceful fallback when showModal is unsupported) ----
  openDialog(t) {
    typeof t.showModal == "function" ? t.showModal() : t.setAttribute("open", "");
  }
  closeDialog(t) {
    typeof t.close == "function" ? t.close() : t.removeAttribute("open");
  }
}
class $ extends HTMLElement {
  connectedCallback() {
    this.target = this.resolveTarget(), this.target && (this.cells = {
      days: this.querySelector('[data-kik-cd="days"]'),
      hours: this.querySelector('[data-kik-cd="hours"]'),
      minutes: this.querySelector('[data-kik-cd="minutes"]'),
      seconds: this.querySelector('[data-kik-cd="seconds"]')
    }, this.tick = this.tick.bind(this), this.tick(), this.timer = setInterval(this.tick, 1e3));
  }
  disconnectedCallback() {
    clearInterval(this.timer);
  }
  resolveTarget() {
    const t = this.dataset.deadline;
    if (t) {
      const i = Date.parse(t.replace(" ", "T"));
      if (!Number.isNaN(i)) return i;
    }
    const e = Number(this.dataset.durationHours);
    return e > 0 ? Date.now() + e * 3600 * 1e3 : null;
  }
  pad(t) {
    return String(Math.max(0, t)).padStart(2, "0");
  }
  tick() {
    let t = Math.floor((this.target - Date.now()) / 1e3);
    t < 0 && (t = 0);
    const e = Math.floor(t / 86400), i = Math.floor(t % 86400 / 3600), s = Math.floor(t % 3600 / 60), r = t % 60;
    this.cells.days && (this.cells.days.textContent = this.pad(e)), this.cells.hours && (this.cells.hours.textContent = this.pad(i)), this.cells.minutes && (this.cells.minutes.textContent = this.pad(s)), this.cells.seconds && (this.cells.seconds.textContent = this.pad(r)), t === 0 && clearInterval(this.timer);
  }
}
customElements.get("kik-product-main") || customElements.define("kik-product-main", K);
customElements.get("kik-countdown") || customElements.define("kik-countdown", $);
class W extends HTMLElement {
  connectedCallback() {
    if (this._wired) return;
    this._wired = !0;
    const t = this.querySelector("[data-quantity]"), e = this.querySelector("[data-add]"), i = this.querySelector("[data-status]");
    this.querySelector("[data-minus]").addEventListener("click", () => t.stepDown()), this.querySelector("[data-plus]").addEventListener("click", () => t.stepUp()), e.addEventListener("click", async () => {
      if (!(e.disabled || !t.reportValidity())) {
        e.disabled = !0, e.setAttribute("aria-busy", "true"), i.textContent = "";
        try {
          const s = window.Shopify?.routes?.root || "/", r = await fetch(`${s}cart/add.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items: [{ id: Number(this.dataset.variantId), quantity: Number(t.value) }] })
          }), o = await r.json();
          if (!r.ok) throw new Error(o.description || o.message || this.dataset.error);
          i.textContent = this.dataset.success;
          const a = this.dataset.discountCode?.trim();
          if (a)
            try {
              await this.applyDiscount(s, a);
            } catch {
            }
          document.dispatchEvent(new CustomEvent("kik-cart:refresh")), document.dispatchEvent(new CustomEvent("kik-cart:open"));
        } catch (s) {
          i.textContent = s.message || this.dataset.error;
        } finally {
          e.disabled = !1, e.removeAttribute("aria-busy");
        }
      }
    });
  }
  async applyDiscount(t, e) {
    const i = await fetch(`${t}cart.js`, { cache: "no-store" });
    if (!i.ok) throw new Error("Cart could not be loaded");
    const s = await i.json(), r = /* @__PURE__ */ new Map();
    for (const c of s.discount_codes || [])
      c.code && c.applicable !== !1 && r.set(c.code.toLowerCase(), c.code);
    r.set(e.toLowerCase(), e);
    const o = await fetch(`${t}cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ discount: [...r.values()].join(",") })
    });
    if (!o.ok) throw new Error("Coupon could not be applied");
    let a = this.appliedCodes(await o.json());
    if (!a.some((c) => c.code.toLowerCase() === e.toLowerCase())) {
      const c = await fetch(`${t}cart.js`, { cache: "no-store" });
      c.ok && (a = this.appliedCodes(await c.json()));
    }
    try {
      const c = a.map((l) => l.code).join(",");
      c ? localStorage.setItem("kik-cart-coupon", c) : localStorage.removeItem("kik-cart-coupon");
    } catch {
    }
    if (!a.some((c) => c.code.toLowerCase() === e.toLowerCase()))
      throw new Error("Coupon is not applicable");
  }
  // Same rule as the cart drawer's coupon validation: a code counts unless Shopify flags it applicable: false.
  appliedCodes(t) {
    return (t.discount_codes || []).filter((e) => e.code && e.applicable !== !1);
  }
}
customElements.get("kik-upsell-controls") || customElements.define("kik-upsell-controls", W);
const k = /* @__PURE__ */ new Map();
function A(n, t, e, i) {
  if (i()) return Promise.resolve();
  if (k.has(n)) return k.get(n);
  const s = new Promise((r, o) => {
    const a = document.createElement("script");
    a.src = t, a.async = !0;
    for (const [l, h] of Object.entries(e)) a.setAttribute(l, h);
    const c = setTimeout(() => {
      a.remove(), o(new Error(`${n} loading timed out`));
    }, 15e3);
    a.onload = () => {
      clearTimeout(c), i() ? r() : o(new Error(`${n} unavailable`));
    }, a.onerror = () => {
      clearTimeout(c), a.remove(), o(new Error(`${n} loading failed`));
    }, document.head.append(a);
  });
  return k.set(n, s), s.catch(() => k.delete(n)), s;
}
class j extends HTMLElement {
  connectedCallback() {
    this.variantRoot = this.closest(".shopify-section"), this.onVariantChange ||= (t) => {
      t.detail?.variant && this.updateAmount(t.detail.variant.price);
    }, this.variantRoot?.addEventListener("on:variant:change", this.onVariantChange), !this.initialized && (this.initialized = !0, this.dialog = this.querySelector("dialog"), this.openButton = this.querySelector("[data-payment-open]"), this.dialog.setAttribute("aria-hidden", "true"), this.dialog.inert = !0, this.openButton.addEventListener("click", () => {
      !this.isConnected || this.dialog.open || (this.dialog.removeAttribute("aria-hidden"), this.dialog.inert = !1, this.dialog.showModal(), this.watchKlarnaPreview(), this.renderProviders());
    }), this.dialog.addEventListener("close", () => {
      window.cancelAnimationFrame?.(this.klarnaPreviewFrame), this.dialog.setAttribute("aria-hidden", "true"), this.dialog.inert = !0;
    }), this.querySelector("[data-payment-close]").addEventListener("click", () => this.dialog.close()), this.dialog.addEventListener("click", (t) => {
      if (t.target !== this.dialog) return;
      const e = this.dialog.getBoundingClientRect();
      (t.clientX < e.left || t.clientX > e.right || t.clientY < e.top || t.clientY > e.bottom) && this.dialog.close();
    }), this.renderProviders());
  }
  updateAmount(t) {
    this.dataset.amount = String(t), this.querySelector("klarna-placement")?.setAttribute("data-purchase-amount", String(t)), this.querySelector("[data-payment-paypal]")?.setAttribute("data-pp-amount", (t / 100).toFixed(2)), this.renderProviders();
  }
  renderProviders() {
    if (this.preparation)
      return this.preparation.then(() => this.preparedAmount === this.dataset.amount ? void 0 : this.renderProviders());
    if (this.preparedAmount === this.dataset.amount) return Promise.resolve();
    const t = this.dataset.amount;
    return this.preparation = Promise.all([this.renderKlarna(), this.renderPayPal()]).then(() => {
      this.preparedAmount = t, this.preparation = null;
    }), this.preparation.then(() => this.preparedAmount === this.dataset.amount ? void 0 : this.renderProviders());
  }
  async renderKlarna() {
    if (this.querySelector('[data-provider="klarna"]')) {
      this.klarnaReady = !1;
      try {
        const e = () => !!window.Klarna?.OnsiteMessaging;
        if (!e()) {
          if (!this.dataset.klarnaClientId) throw new Error("Klarna client ID missing");
          await A("klarna", "https://js.klarna.com/web-sdk/v1/klarna.js", {
            "data-client-id": this.dataset.klarnaClientId,
            "data-environment": "production"
          }, e);
        }
        this.klarnaEventsBound || (window.Klarna.OnsiteMessaging.on("placement-rendered", () => {
          this.klarnaReady = !0, this.syncKlarnaPreview(), clearTimeout(this.klarnaTimeout), this.resolveKlarna?.();
        }), window.Klarna.OnsiteMessaging.on("informational-modal-opened", () => {
          this.dialog.open && this.dialog.close();
        }), this.klarnaEventsBound = !0), clearTimeout(this.klarnaTimeout), await new Promise((i) => {
          this.resolveKlarna = i, this.klarnaTimeout = setTimeout(i, 15e3), window.Klarna.OnsiteMessaging.refresh();
        });
      } catch {
        this.klarnaReady = !1;
      }
    }
  }
  syncKlarnaPreview() {
    const t = this.querySelector("[data-klarna-preview]"), e = this.querySelector("klarna-placement");
    !t || !e || (t.hidden = (e.getBoundingClientRect?.().height || 0) > 0);
  }
  watchKlarnaPreview() {
    this.syncKlarnaPreview(), this.dialog.open && this.isConnected && window.requestAnimationFrame && (this.klarnaPreviewFrame = window.requestAnimationFrame(() => this.watchKlarnaPreview()));
  }
  async renderPayPal() {
    const t = this.querySelector('[data-provider="paypal"]'), e = this.querySelector("[data-payment-paypal]");
    if (!(!t || !e)) {
      this.paypalReady = !1;
      try {
        let i = window.kikPayPalMessaging || window.paypal;
        if (!i?.Messages) {
          if (!this.dataset.paypalClientId) throw new Error("PayPal client ID missing");
          const s = new URLSearchParams({
            "client-id": this.dataset.paypalClientId,
            components: "messages",
            currency: this.dataset.currency
          });
          await A(`paypal-${this.dataset.currency}`, `https://www.paypal.com/sdk/js?${s}`, {
            "data-namespace": "kikPayPalMessaging"
          }, () => !!window.kikPayPalMessaging?.Messages), i = window.kikPayPalMessaging;
        }
        if (!this.isConnected) return;
        await i.Messages({
          amount: Number(this.dataset.amount) / 100,
          currency: this.dataset.currency,
          pageType: "product-details",
          style: { layout: "text", logo: { type: "inline" }, text: { size: 14 } },
          onClick: () => {
            this.dialog.open && this.dialog.close();
          }
        }).render(e), this.paypalReady = !!e.querySelector("iframe"), this.paypalReady || t.remove(), this.querySelectorAll("[data-payment-paypal-summary]").forEach((s) => {
          s.hidden = !this.paypalReady;
        });
      } catch {
        this.paypalReady = !1, t.remove(), this.querySelectorAll("[data-payment-paypal-summary]").forEach((i) => {
          i.hidden = !0;
        });
      }
    }
  }
  disconnectedCallback() {
    window.cancelAnimationFrame?.(this.klarnaPreviewFrame), this.variantRoot?.removeEventListener("on:variant:change", this.onVariantChange), clearTimeout(this.klarnaTimeout), this.resolveKlarna?.();
  }
}
customElements.get("kik-payment-options") || customElements.define("kik-payment-options", j);
class X extends HTMLElement {
  connectedCallback() {
    this.quote = this.querySelector("[data-kik-review-quote]"), this.button = this.querySelector("[data-kik-review-open]"), this.dialog = this.querySelector("dialog"), this.closeButton = this.querySelector("[data-kik-review-close]"), this.imageButton = this.querySelector("[data-kik-review-image-open]"), this.imageDialog = this.querySelector("[data-kik-review-image-dialog]"), this.imageCloseButton = this.querySelector("[data-kik-review-image-close]"), !(!this.quote || !this.button || !this.dialog) && (this.onOpen = () => this.dialog.showModal(), this.onClose = () => this.dialog.close(), this.onBackdrop = (t) => {
      t.target === this.dialog && this.dialog.close();
    }, this.onClosed = () => this.button.focus(), this.button.addEventListener("click", this.onOpen), this.closeButton.addEventListener("click", this.onClose), this.dialog.addEventListener("click", this.onBackdrop), this.dialog.addEventListener("close", this.onClosed), this.mobileViewport = window.matchMedia("(max-width: 767px)"), this.onImageOpen = () => {
      this.mobileViewport.matches && this.imageDialog?.showModal();
    }, this.onImageClose = () => this.imageDialog?.close(), this.onImageBackdrop = (t) => {
      t.target === this.imageDialog && this.imageDialog.close();
    }, this.onImageClosed = () => this.imageButton?.focus(), this.imageButton?.addEventListener("click", this.onImageOpen), this.imageCloseButton?.addEventListener("click", this.onImageClose), this.imageDialog?.addEventListener("click", this.onImageBackdrop), this.imageDialog?.addEventListener("close", this.onImageClosed), this.onViewportChange = () => {
      !this.mobileViewport.matches && this.imageDialog?.open && this.imageDialog.close();
    }, this.mobileViewport.addEventListener("change", this.onViewportChange), this.observer = new ResizeObserver(() => this.measure()), this.observer.observe(this.quote), this.measure(), document.fonts.ready.then(() => {
      this.isConnected && this.measure();
    }));
  }
  measure() {
    this.quote.getBoundingClientRect().width && (this.button.hidden = this.quote.scrollHeight <= this.quote.clientHeight + 1);
  }
  disconnectedCallback() {
    this.observer?.disconnect(), this.imageDialog?.open && this.imageDialog.close(), this.dialog?.open && this.dialog.close(), this.button?.removeEventListener("click", this.onOpen), this.closeButton?.removeEventListener("click", this.onClose), this.dialog?.removeEventListener("click", this.onBackdrop), this.dialog?.removeEventListener("close", this.onClosed), this.imageButton?.removeEventListener("click", this.onImageOpen), this.imageCloseButton?.removeEventListener("click", this.onImageClose), this.imageDialog?.removeEventListener("click", this.onImageBackdrop), this.imageDialog?.removeEventListener("close", this.onImageClosed), this.mobileViewport?.removeEventListener("change", this.onViewportChange);
  }
}
customElements.get("kik-review-card") || customElements.define("kik-review-card", X);
class U extends HTMLElement {
  connectedCallback() {
    this.quotes = [...this.querySelectorAll("[data-kik-cr-quote]")], this.dialogs = [...this.querySelectorAll("dialog[data-kik-cr-dialog]")], this.zoomDialogs = [...this.querySelectorAll("dialog[data-kik-cr-zoom-dialog]")], this.onClick = (t) => {
      const e = t.target.closest("[data-kik-cr-close]");
      if (e) return e.closest("dialog")?.close();
      const i = t.target.closest("[data-kik-cr-open]");
      if (i) return this.open(i);
      const s = t.target.closest("[data-kik-cr-zoom]");
      if (s) return this.openZoom(s);
      t.target.matches("dialog[data-kik-cr-dialog], dialog[data-kik-cr-zoom-dialog]") && t.target.close();
    }, this.mobileViewport = window.matchMedia("(max-width: 767px)"), this.onViewportChange = () => {
      this.mobileViewport.matches || this.zoomDialogs.forEach((t) => {
        t.open && t.close();
      });
    }, this.mobileViewport.addEventListener("change", this.onViewportChange), this.onClosed = (t) => {
      t.target.querySelectorAll("video").forEach((e) => e.pause()), this.lastTrigger?.focus();
    }, this.onZoomClosed = (t) => t.target.querySelector("video")?.pause(), this.addEventListener("click", this.onClick), this.dialogs.forEach((t) => t.addEventListener("close", this.onClosed)), this.zoomDialogs.forEach((t) => t.addEventListener("close", this.onZoomClosed)), this.observer = new ResizeObserver(() => this.measure()), this.quotes.forEach((t) => this.observer.observe(t)), this.measure(), document.fonts?.ready.then(() => {
      this.isConnected && this.measure();
    });
  }
  open(t) {
    const e = this.querySelector(`#${CSS.escape(t.dataset.kikCrOpen)}`);
    !e || e.open || (this.lastTrigger = t, e.showModal(), t.hasAttribute("data-kik-cr-play") && !this.mobileViewport.matches && e.querySelector("video[data-kik-cr-inline-video]")?.play().catch(() => {
    }));
  }
  openZoom(t) {
    if (!this.mobileViewport.matches) return;
    const e = this.querySelector(`#${CSS.escape(t.dataset.kikCrZoom)}`);
    !e || e.open || (e.showModal(), e.querySelector("video")?.play().catch(() => {
    }));
  }
  measure() {
    this.quotes.forEach((t) => {
      if (!t.clientHeight) return;
      t.closest("[data-kik-cr-card]")?.querySelector("[data-kik-cr-more]")?.classList.toggle("invisible", t.scrollHeight <= t.clientHeight + 1);
    });
  }
  disconnectedCallback() {
    this.observer?.disconnect(), this.removeEventListener("click", this.onClick), this.mobileViewport?.removeEventListener("change", this.onViewportChange), this.zoomDialogs?.forEach((t) => t.removeEventListener("close", this.onZoomClosed)), this.dialogs?.forEach((t) => {
      t.removeEventListener("close", this.onClosed), t.open && t.close();
    });
  }
}
customElements.get("kik-customer-review") || customElements.define("kik-customer-review", U);
class G extends HTMLElement {
  connectedCallback() {
    if (this.frame = this.querySelector(".kik-sv__frame"), this.measure = this.querySelector("[data-sv-measure]"), !!this.frame) {
      if (this.enabled = this.dataset.shrink !== "false", this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches, !this.enabled || this.reduceMotion) {
        this.setProgress(1);
        return;
      }
      this.ticking = !1, this.onScroll = this.onScroll.bind(this), this.onResize = this.onResize.bind(this), this.updateContained(), this.update(), window.addEventListener("scroll", this.onScroll, { passive: !0 }), window.addEventListener("resize", this.onResize);
    }
  }
  disconnectedCallback() {
    this.onScroll && window.removeEventListener("scroll", this.onScroll), this.onResize && window.removeEventListener("resize", this.onResize);
  }
  updateContained() {
    const t = this.measure ? this.measure.clientWidth : this.clientWidth;
    t > 0 && this.style.setProperty("--sv-contained", `${t}px`);
  }
  onResize() {
    this.updateContained(), this.update();
  }
  onScroll() {
    this.ticking || (this.ticking = !0, requestAnimationFrame(() => {
      this.update(), this.ticking = !1;
    }));
  }
  update() {
    const t = this.getBoundingClientRect(), e = window.innerHeight || 1, i = e * 0.85, s = e * 0.25, r = (i - t.top) / (i - s || 1);
    this.setProgress(Math.min(Math.max(r, 0), 1));
  }
  setProgress(t) {
    this.style.setProperty("--sv-progress", t.toFixed(4));
  }
}
customElements.get("kik-shrink-video") || customElements.define("kik-shrink-video", G);
const q = "kik-cart-coupon", Q = "kik_cart_coupon";
class J extends HTMLElement {
  connectedCallback() {
    this._wired || (this._wired = !0, this.sectionId = this.dataset.sectionId, this.thresholdCents = parseInt(this.dataset.thresholdCents || "0", 10), this.recommendationsEnabled = this.dataset.recommendations === "true", this.recommendationsLimit = parseInt(this.dataset.recommendationsLimit || "6", 10), this.moneyFormat = this.dataset.moneyFormat || "${{amount}}", this.body = this.querySelector("[data-cart-body]"), this.footer = this.querySelector("[data-cart-footer]"), this._recsToken = 0, this._recsAbort = null, this._refreshToken = 0, this._refreshAbort = null, this._bind(), this._hijackCartIcon(), this._hijackAddToCartForms(), this._restoreCoupon(), this._loadRecommendations());
  }
  // Intercept clicks on any submit-button inside a form that POSTs to /cart/add.
  // preventDefault kills BOTH the form submit AND any parent <a> navigation
  // (stopPropagation alone doesn't block anchor default navigation). Then we
  // add via AJAX and open the drawer.
  _hijackAddToCartForms() {
    this._addToCartHandler = (t) => {
      const e = t.target.closest('button[type="submit"], input[type="submit"]');
      if (!e) return;
      const i = e.closest("form");
      if (!i) return;
      const s = (i.getAttribute("action") || "").split("?")[0];
      if (!/\/cart\/add\/?$/.test(s)) return;
      t.preventDefault(), t.stopImmediatePropagation();
      const r = i.querySelector('[name="id"]'), o = i.querySelector('[name="quantity"]');
      if (!r || !r.value) return;
      const a = o && parseInt(o.value, 10) || 1, c = {};
      i.querySelectorAll('[name^="properties["]').forEach((d) => {
        const m = d.name.match(/properties\[(.+)\]/);
        m && d.value && (c[m[1]] = d.value);
      });
      const h = i.querySelector('[name="selling_plan"]')?.value || null;
      this._addVariant(r.value, a, { properties: c, sellingPlan: h });
    }, document.addEventListener("click", this._addToCartHandler, !0);
  }
  // Intercept cart-icon clicks in capture phase so the Focal cart-drawer's
  // bubble-phase handler never fires. Matches the legacy Focal `#cart-icon`
  // and the kik-header triggers tagged with `[data-kik-cart-trigger]` (two —
  // one desktop, one mobile). Skip on the /cart page (let it navigate).
  _hijackCartIcon() {
    const t = () => window.location.pathname.replace(/\/$/, "") === "/cart", e = (i) => i.target.closest("#cart-icon, [data-kik-cart-trigger]");
    this._cartIconHandler = (i) => {
      !e(i) || t() || (i.preventDefault(), i.stopImmediatePropagation(), this.open());
    }, this._cartIconKeyHandler = (i) => {
      i.key !== " " && i.key !== "Enter" || !e(i) || t() || (i.preventDefault(), i.stopImmediatePropagation(), this.open());
    }, document.addEventListener("click", this._cartIconHandler, !0), document.addEventListener("keydown", this._cartIconKeyHandler, !0);
  }
  _bind() {
    this.addEventListener("click", this._onClick), this.addEventListener("submit", this._onSubmit), this.addEventListener("input", this._onInput), document.addEventListener("kik-cart:open", this._openHandler = () => this.open()), document.addEventListener("kik-cart:close", this._closeHandler = () => this.close()), document.addEventListener("kik-cart:refresh", this._refreshHandler = () => this.refresh()), document.addEventListener("keydown", this._keyHandler = (t) => {
      if (t.key === "Escape" && this.classList.contains("is-open") && this.close(), t.key === "Tab" && this.dataset.modalOpen === "true") {
        const i = this.querySelector("[data-cart-tab-panel].is-open")?.querySelectorAll("button:not(:disabled), input, textarea, a[href]");
        if (!i?.length) return;
        const s = i[0], r = i[i.length - 1];
        t.shiftKey && document.activeElement === s ? (t.preventDefault(), r.focus()) : !t.shiftKey && document.activeElement === r && (t.preventDefault(), s.focus());
      }
    });
  }
  disconnectedCallback() {
    document.removeEventListener("kik-cart:open", this._openHandler), document.removeEventListener("kik-cart:close", this._closeHandler), document.removeEventListener("kik-cart:refresh", this._refreshHandler), document.removeEventListener("keydown", this._keyHandler), document.removeEventListener("click", this._cartIconHandler, !0), document.removeEventListener("keydown", this._cartIconKeyHandler, !0), this._addToCartHandler && document.removeEventListener("click", this._addToCartHandler, !0);
  }
  // ---------- open / close ----------
  open() {
    this.classList.add("is-open"), this.setAttribute("aria-hidden", "false"), document.documentElement.style.overflow = "hidden", document.dispatchEvent(new CustomEvent("kik-cart:opened"));
  }
  close() {
    if (this.getAttribute("data-modal-open") === "true") {
      this._closeAllTabs();
      return;
    }
    this.classList.remove("is-open"), this.setAttribute("aria-hidden", "true"), document.documentElement.style.overflow = "", this._closeAllTabs(), document.dispatchEvent(new CustomEvent("kik-cart:closed"));
  }
  // ---------- delegated events ----------
  _onClick = (t) => {
    const e = t.target;
    if (e.closest("[data-cart-close]")) {
      t.preventDefault(), this.close();
      return;
    }
    const i = e.closest("[data-cart-tab]");
    if (i) {
      t.preventDefault(), this._toggleTab(i.dataset.cartTab, i);
      return;
    }
    if (e.closest("[data-cart-tab-close-all]")) {
      t.preventDefault(), this._closeAllTabs();
      return;
    }
    const s = e.closest("[data-cart-tab-close]");
    if (s) {
      t.preventDefault(), this._closeTab(s.dataset.cartTabClose);
      return;
    }
    const r = e.closest("[data-cart-qty-decrement]"), o = e.closest("[data-cart-qty-increment]"), a = e.closest("[data-cart-remove]");
    if (r || o || a) {
      t.preventDefault();
      const h = e.closest("[data-cart-line]");
      if (!h) return;
      const d = h.dataset.key, m = h.querySelector("[data-cart-qty-value]");
      let f = parseInt(m?.textContent || "0", 10);
      a ? f = 0 : r ? f = Math.max(0, f - 1) : o && (f = f + 1), this._updateLine(d, f);
      return;
    }
    const c = e.closest("[data-cart-checkout]");
    if (c) {
      const h = this._getStoredCoupon();
      if (h) {
        t.preventDefault();
        const d = new URL(c.href, window.location.origin);
        d.searchParams.set("discount", h), window.location.href = d.toString();
      }
      return;
    }
    const l = e.closest(".kik-cart-rec-cta");
    if (l) {
      t.preventDefault();
      const h = l.dataset.variantId, d = l.dataset.productUrl;
      h ? this._addVariant(h) : d && (this.close(), window.location.href = d);
      return;
    }
  };
  _onSubmit = (t) => {
    if (t.target.matches("[data-cart-note-form]")) {
      t.preventDefault(), this._saveOrderNote(t.target);
      return;
    }
    if (t.target.matches("[data-cart-coupon-form]")) {
      t.preventDefault();
      const e = t.target, s = (e.querySelector("[data-cart-coupon-input]")?.value || "").trim().toUpperCase(), r = e.closest("[data-cart-tab-panel]"), o = e.querySelector('button[type="submit"]');
      if (!s) {
        r?.setAttribute("data-error", "true");
        return;
      }
      this._validateAndApplyCoupon(s, r, o);
    }
  };
  // Validate against Shopify by asking /cart/update.js to apply the code.
  // If the response cart includes the code as applied (or applicable), it's real.
  // Otherwise show the error state and don't store it.
  async _validateAndApplyCoupon(t, e, i) {
    i && (i.disabled = !0), e?.removeAttribute("data-error");
    try {
      if (!((await (await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ discount: t })
      })).json().catch(() => ({}))).discount_codes || []).some(
        (a) => a.code && a.code.toLowerCase() === t.toLowerCase() && a.applicable !== !1
      )) {
        e?.setAttribute("data-error", "true");
        return;
      }
      this._storeCoupon(t), this._renderCouponBadge(), await this.refresh(), this._closeTab("coupon");
    } catch (s) {
      console.error("[kik-cart] coupon validation failed", s), e?.setAttribute("data-error", "true");
    } finally {
      i && (i.disabled = !1);
    }
  }
  _onInput = (t) => {
    if (t.target.matches("[data-cart-note]")) {
      const e = t.target.closest("form")?.querySelector("[data-cart-note-error]");
      e && (e.hidden = !0);
    }
    t.target.matches("[data-cart-coupon-input]") && t.target.closest("[data-cart-tab-panel]")?.removeAttribute("data-error");
  };
  async _saveOrderNote(t) {
    const e = t.querySelector("[data-cart-note]"), i = t.querySelector('button[type="submit"]'), s = t.querySelector("[data-cart-note-error]");
    if (!(i?.disabled || !e)) {
      i && (i.disabled = !0), s && (s.hidden = !0);
      try {
        const r = await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ note: e.value })
        });
        if (!r.ok) throw new Error("Order note save failed");
        const o = await r.json();
        e.defaultValue = o.note || "", e.value = e.defaultValue, this._closeTab("note");
      } catch {
        s && (s.hidden = !1);
      } finally {
        i && (i.disabled = !1);
      }
    }
  }
  // ---------- tabs ----------
  _toggleTab(t, e) {
    if (this.querySelector(`[data-cart-tab-panel="${t}"]`)?.classList.contains("is-open")) {
      this._closeAllTabs();
      return;
    }
    this._closeAllTabs(!1);
    const s = this.querySelector(`[data-cart-tab-panel="${t}"]`);
    if (s) {
      if (this._modalTrigger = e || this.querySelector(`[data-cart-tab="${t}"]`), s.classList.add("is-open"), s.setAttribute("aria-hidden", "false"), s.inert = !1, this.querySelectorAll(`[data-cart-tab="${t}"]`).forEach((r) => r.setAttribute("aria-expanded", "true")), this.setAttribute("data-modal-open", "true"), this.body && (this.body.inert = !0), this.footer && (this.footer.inert = !0), t === "note") {
        const r = s.querySelector("[data-cart-note]");
        r && (r.value = r.defaultValue);
        const o = s.querySelector("[data-cart-note-error]");
        o && (o.hidden = !0);
      }
      s.querySelector("input, textarea, button, a[href]")?.focus({ preventScroll: !0 });
    }
  }
  _closeTab() {
    this._closeAllTabs();
  }
  _closeAllTabs(t = !0) {
    if (this.querySelectorAll("[data-cart-tab-panel]").forEach((e) => {
      e.classList.remove("is-open"), e.setAttribute("aria-hidden", "true"), e.inert = !0;
    }), this.querySelectorAll("[data-cart-tab]").forEach((e) => e.setAttribute("aria-expanded", "false")), this.removeAttribute("data-modal-open"), this.body && (this.body.inert = !1), this.footer && (this.footer.inert = !1), t) {
      const e = this._modalTrigger?.dataset?.cartTab;
      (this._modalTrigger?.isConnected === !1 && e ? this.querySelector(`[data-cart-tab="${e}"]`) : this._modalTrigger)?.focus({ preventScroll: !0 });
    }
    this._modalTrigger = null;
  }
  // ---------- cart mutations ----------
  async _updateLine(t, e) {
    this.dataset.loading = "true";
    try {
      const i = { id: t, quantity: e };
      this.sectionId && (i.sections = this.sectionId);
      const s = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(i)
      });
      if (!s.ok) throw new Error("Cart update failed");
      const r = await s.json().catch(() => ({}));
      this._applyCartResponse(r) || await this.refresh();
    } catch (i) {
      console.error("[kik-cart] update failed", i);
    } finally {
      this.dataset.loading = "false";
    }
  }
  async _addVariant(t, e = 1, i = {}) {
    this.dataset.loading = "true", this.classList.contains("is-open") || this.open();
    try {
      const s = { id: t, quantity: e };
      i.properties && Object.keys(i.properties).length && (s.properties = i.properties), i.sellingPlan && (s.selling_plan = i.sellingPlan);
      const r = [s];
      Array.isArray(i.extraItems) && i.extraItems.length && r.push(...i.extraItems);
      const o = { items: r };
      this.sectionId && (o.sections = this.sectionId);
      const a = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(o)
      });
      if (!a.ok) {
        const l = await a.json().catch(() => ({}));
        throw new Error(l.description || l.message || "Add to cart failed");
      }
      const c = await a.json().catch(() => ({}));
      this._applyCartResponse(c) || await this.refresh();
    } catch (s) {
      console.error("[kik-cart] add failed", s);
    } finally {
      this.dataset.loading = "false";
    }
  }
  // Apply the pre-rendered section HTML returned by /cart/add.js|/cart/change.js
  // when we pass `sections: <id>` in the body. Returns true when the DOM was
  // updated so callers can skip the fallback refresh() round-trip.
  _applyCartResponse(t) {
    const e = t && t.sections && t.sections[this.sectionId];
    if (!e) return !1;
    try {
      const i = new DOMParser().parseFromString(e, "text/html"), s = i.querySelector(`#${this.id}`) || i.body.firstElementChild;
      return s ? (this._applyFreshSection(s), this._loadRecommendations(), document.dispatchEvent(new CustomEvent("kik-cart:refreshed")), !0) : !1;
    } catch (i) {
      return console.warn("[kik-cart] applyCartResponse failed", i), !1;
    }
  }
  _applyFreshSection(t) {
    const e = t.querySelector("[data-cart-body]"), i = t.querySelector("[data-cart-footer]"), s = t.querySelector("[data-cart-count]"), r = t.querySelector("[data-cart-progress]");
    if (e && this.body && (this.body.innerHTML = e.innerHTML), i && this.footer && (this.footer.innerHTML = i.innerHTML), s) {
      const c = this.querySelector("[data-cart-count]");
      c && (c.textContent = s.textContent);
      const l = Number(s.textContent.trim());
      Number.isFinite(l) && document.querySelectorAll("[data-kik-cart-count]").forEach((h) => {
        h.textContent = String(l), h.hidden = l === 0;
      });
    }
    if (r) {
      const c = this.querySelector("[data-cart-progress]");
      c && c.replaceWith(r);
    }
    const o = t.querySelector("[data-cart-note]"), a = this.querySelector("[data-cart-note]");
    o && a && this.dataset.modalOpen !== "true" && (a.defaultValue = o.value, a.value = o.value), this._renderCouponBadge();
  }
  // ---------- re-render from Section Rendering API ----------
  async refresh() {
    if (!this.sectionId) return;
    this._refreshAbort && this._refreshAbort.abort(), this._refreshAbort = new AbortController();
    const t = this._refreshAbort.signal, e = ++this._refreshToken;
    try {
      const i = `${window.location.pathname}?section_id=${this.sectionId}&_t=${Date.now()}`, s = await fetch(i, { cache: "no-store", signal: t });
      if (!s.ok) throw new Error("Section render failed");
      const r = await s.text();
      if (e !== this._refreshToken) return;
      const a = new DOMParser().parseFromString(r, "text/html").querySelector(`#${this.id}`);
      if (!a) return;
      this._applyFreshSection(a), this._loadRecommendations(), document.dispatchEvent(new CustomEvent("kik-cart:refreshed"));
    } catch (i) {
      if (i.name === "AbortError") return;
      console.error("[kik-cart] refresh failed", i);
    }
  }
  // ---------- coupon storage ----------
  _storeCoupon(t) {
    try {
      localStorage.setItem(q, t);
    } catch {
    }
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ attributes: { [Q]: t } })
    });
  }
  _getStoredCoupon() {
    try {
      return localStorage.getItem(q) || "";
    } catch {
      return "";
    }
  }
  _restoreCoupon() {
    const t = this._getStoredCoupon(), e = this.querySelector("[data-cart-coupon-input]");
    e && t && (e.value = t), this._renderCouponBadge();
  }
  _renderCouponBadge() {
    const t = this.querySelector("[data-cart-coupon-count]");
    t && (this._getStoredCoupon() ? t.hidden = !1 : t.hidden = !0);
  }
  // ---------- recommendations ----------
  async _loadRecommendations() {
    if (!this.recommendationsEnabled) return;
    this._recsAbort && this._recsAbort.abort(), this._recsAbort = new AbortController();
    const t = this._recsAbort.signal, e = ++this._recsToken;
    let i = this.querySelector("[data-cart-recs]"), s = this.querySelector("[data-cart-recs-list]");
    if (!i || !s) return;
    let r = i.dataset.firstProductId;
    if (!r) {
      try {
        const o = await fetch("/cart.js", { signal: t });
        if (o.ok) {
          const a = await o.json();
          r = a.items && a.items[0] ? String(a.items[0].product_id) : "";
        }
      } catch (o) {
        if (o.name === "AbortError") return;
      }
      if (e !== this._recsToken) return;
    }
    if (i = this.querySelector("[data-cart-recs]"), s = this.querySelector("[data-cart-recs-list]"), !(!i || !s)) {
      if (!r) {
        i.hidden = !0;
        return;
      }
      try {
        const o = `/recommendations/products.json?product_id=${r}&limit=${this.recommendationsLimit}&intent=related`, a = await fetch(o, { signal: t });
        if (!a.ok) throw new Error("Recs fetch failed");
        const c = await a.json();
        if (e !== this._recsToken || (i = this.querySelector("[data-cart-recs]"), s = this.querySelector("[data-cart-recs-list]"), !i || !s)) return;
        const l = (c.products || []).slice(0, this.recommendationsLimit);
        if (l.length === 0) {
          i.hidden = !0;
          return;
        }
        s.innerHTML = l.map((h) => this._recCard(h)).join(""), i.hidden = !1;
      } catch (o) {
        if (o.name === "AbortError") return;
        console.warn("[kik-cart] recommendations skipped", o);
        const a = this.querySelector("[data-cart-recs]");
        a && (a.hidden = !0);
      }
    }
  }
  _recCard(t) {
    const e = t.variants && t.variants[0], i = this._money(t.price), s = t.featured_image || t.images && t.images[0] || "", r = t.variants && t.variants.length > 1, o = r ? "Choose options" : "Add to cart", a = r ? `data-product-url="${t.url}"` : `data-cart-rec-add data-variant-id="${e?.id ?? ""}"`;
    return `
      <div class="kik-cart-rec">
        <a class="kik-cart-rec-media" href="${t.url}" aria-hidden="true" tabindex="-1">
          ${s ? `<img src="${s}" alt="${this._esc(t.title)}" loading="lazy" width="80" height="80" />` : ""}
        </a>
        <div class="kik-cart-rec-body">
          <a class="kik-cart-rec-title" href="${t.url}">${this._esc(t.title)}</a>
          <p class="kik-cart-rec-price">${i}</p>
          <button type="button" class="kik-cart-rec-cta" ${a}>${o}</button>
        </div>
      </div>
    `;
  }
  // ---------- utils ----------
  _esc(t) {
    return String(t).replace(/[&<>"']/g, (e) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[e]);
  }
  _money(t) {
    const e = (t / 100).toFixed(2);
    return this.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, e).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(t / 100));
  }
}
customElements.get("kik-cart-drawer") || customElements.define("kik-cart-drawer", J);
class Z extends HTMLElement {
  connectedCallback() {
    this.dataset.init === "1" || (this.dataset.init = "1", window.matchMedia("(prefers-reduced-motion: reduce)").matches) || (this.animationDuration = 600, this.fastAnimationDuration = 200, this.wheelThreshold = 8, this.touchThreshold = 40, this.edgeTolerance = 4, this.gestureQuietMs = 100, this.rearmDelta = 400, this.fastGestureDelta = 240, this.fastGestureSpeed = 1.2, this.snapDriftTolerance = 8, this.lastWheelTs = 0, this.snapDuration = this.animationDuration, this.scrubEase = 0.2, this.resetWheelGesture(0, 0), this.isAnimating = !1, this.animationTimer = 0, this.rafHandle = 0, this.sections = this.collectSections(), !(this.sections.length < 2) && (this.updateHeaderVar(), this.currentIndex = this.findClosestIndex(), this.loaded = document.readyState === "complete", this.loaded || (this.onLoad = () => {
      this.loaded = !0, this.currentIndex = this.findClosestIndex();
    }, window.addEventListener("load", this.onLoad, { once: !0 })), this.onWheel = this.onWheel.bind(this), this.onTouchStart = this.onTouchStart.bind(this), this.onTouchMove = this.onTouchMove.bind(this), this.onTouchEnd = this.onTouchEnd.bind(this), this.onKey = this.onKey.bind(this), this.onResize = this.onResize.bind(this), this.onScroll = this.onScroll.bind(this), this.scrubStep = this.scrubStep.bind(this), window.addEventListener("wheel", this.onWheel, { passive: !1 }), window.addEventListener("touchstart", this.onTouchStart, { passive: !0 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !0 }), window.addEventListener("keydown", this.onKey), window.addEventListener("resize", this.onResize), window.addEventListener("scroll", this.onScroll, { passive: !0 })));
  }
  disconnectedCallback() {
    window.removeEventListener("wheel", this.onWheel, { passive: !1 }), window.removeEventListener("touchstart", this.onTouchStart), window.removeEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.removeEventListener("touchend", this.onTouchEnd), window.removeEventListener("keydown", this.onKey), window.removeEventListener("resize", this.onResize), window.removeEventListener("scroll", this.onScroll), this.onLoad && window.removeEventListener("load", this.onLoad), clearTimeout(this.animationTimer), cancelAnimationFrame(this.rafHandle), cancelAnimationFrame(this.syncRaf), cancelAnimationFrame(this.scrubRaf);
  }
  collectSections() {
    const t = document.querySelector("main") || document.body;
    return Array.from(t.querySelectorAll(":scope > .shopify-section")).filter((i) => i.offsetHeight > 0 && !i.contains(this));
  }
  findClosestIndex() {
    const t = this.getHeaderHeight() + 1;
    let e = 0, i = 1 / 0, s = !1;
    return this.sections.forEach((r, o) => {
      if (s) return;
      const a = r.getBoundingClientRect();
      if (a.top <= t && a.bottom > t) {
        e = o, s = !0;
        return;
      }
      const c = Math.min(Math.abs(a.top - t), Math.abs(a.bottom - t));
      c < i && (i = c, e = o);
    }), e;
  }
  /* Whether this snapper is allowed to take a gesture yet.
   *
   * Until `load`, it must not. On a reload or a back-navigation the browser
   * restores the previous scroll offset, and it keeps re-applying that offset as
   * the document grows — right up until the visitor makes a real scroll gesture,
   * which is the only thing that cancels it. Ours never counts: we preventDefault
   * the wheel and move the page with window.scrollTo, and a programmatic scroll
   * leaves the pending restore intact. So a snap that lands mid-load gets silently
   * overwritten the moment loading finishes, dropping the visitor back on the
   * section they arrived at — after visibly animating away from it.
   *
   * Letting those early gestures scroll natively costs a few hundred ms of
   * snapping on a cold load and cancels the restore the way the browser expects.
   * We resync currentIndex on `load` so the first snap starts from wherever the
   * visitor actually ended up. */
  takesGestures() {
    return this.loaded;
  }
  /* The section a gesture acts on, re-derived from where the page actually is.
   *
   * currentIndex is only a memory of the last snap, and onScroll can't always
   * keep it honest: a document that changes height (a late-loading image, an app
   * block, a section that measures itself after load) moves the visitor into a
   * different section without firing a scroll event, and from then on we swallow
   * their gestures with preventDefault so no native scroll ever happens to
   * correct us either. A stale index is not a cosmetic problem here — every
   * clamp in scrubControlled is measured against the section it names, so it
   * would drag the visitor into a section they'd already left. Mid-snap we keep
   * the stored index: the page is passing through sections we chose, and
   * re-deriving it would fight our own animation. */
  currentSection() {
    return this.isAnimating || (this.currentIndex = this.findClosestIndex()), this.sections[this.currentIndex];
  }
  onScroll() {
    this.scrubRaf && Math.abs(window.scrollY - this.expectedScrollY) > 2 && this.endScrub(), !(this.isAnimating || this.syncRaf) && (this.syncRaf = requestAnimationFrame(() => {
      this.syncRaf = 0, this.isAnimating || (this.currentIndex = this.findClosestIndex());
    }));
  }
  onResize() {
    this.updateHeaderVar(), this.currentIndex = this.findClosestIndex();
  }
  updateHeaderVar() {
    document.documentElement.style.setProperty("--kik-header-h", this.getHeaderHeight() + "px");
  }
  onKey(t) {
    if (!this.takesGestures() || this.isTypingTarget(document.activeElement)) return;
    this.snapDuration = this.animationDuration, this.scrubEase = 0.2;
    const e = this.currentSection(), i = this.controlledOf(e), s = t.key === "ArrowDown" || t.key === "PageDown" || t.key === " ", r = t.key === "ArrowUp" || t.key === "PageUp";
    if (s || r) {
      const o = s ? 1 : -1;
      if (i && !this.isAnimating) {
        const c = t.key === "PageDown" || t.key === "PageUp" || t.key === " " ? window.innerHeight * 0.8 : 120;
        t.preventDefault(), i.smooth ? this.scrubSmooth(i, o, c) : this.scrubControlled(i, o, c);
        return;
      }
      this.snap(this.currentIndex + o, o) && t.preventDefault();
    } else t.key === "Home" ? this.snap(0, 1) && t.preventDefault() : t.key === "End" && this.snap(this.sections.length - 1, 1) && t.preventDefault();
  }
  /* deltaY in pixels, whatever unit the device reports it in. Line/page wheels
   * must scrub at the same rate as pixel wheels. */
  wheelPixels(t) {
    return t.deltaMode === 1 ? t.deltaY * 16 : t.deltaMode === 2 ? t.deltaY * window.innerHeight : t.deltaY;
  }
  resetWheelGesture(t, e) {
    this.gestureDir = t, this.gestureStart = e, this.gestureTotal = 0, this.gesturePrev = 0, this.gestureSnapped = !1, this.deltaSinceSnap = 0, this.scrubEase = 0.2;
  }
  /* A flick, as opposed to a deliberate nudge: enough travel, delivered fast.
   * The travel floor keeps a single mouse-wheel notch (one ~100px event) out of
   * it — that's a slow, precise gesture that still deserves the full ease. */
  gestureIsFast(t) {
    return this.gestureTotal < this.fastGestureDelta ? !1 : this.gestureTotal / Math.max(50, t - this.gestureStart) >= this.fastGestureSpeed;
  }
  onWheel(t) {
    if (!this.takesGestures() || this.isTypingTarget(t.target) || this.isInsideScrollable(t.target)) return;
    const e = this.wheelPixels(t);
    if (e === 0) return;
    const i = Math.abs(e), s = e > 0 ? 1 : -1, r = performance.now(), o = r - this.lastWheelTs;
    if (this.lastWheelTs = r, (o > this.gestureQuietMs || s !== this.gestureDir || i > this.gesturePrev * 2 && i > 12) && this.resetWheelGesture(s, r), this.gesturePrev = i, this.gestureTotal += i, this.deltaSinceSnap += i, i < this.wheelThreshold) return;
    const a = this.gestureIsFast(r);
    if (this.snapDuration = a ? this.fastAnimationDuration : this.animationDuration, this.scrubEase = a ? 0.45 : 0.2, this.gestureSnapped) {
      if (this.isAnimating || this.deltaSinceSnap < this.rearmDelta) {
        t.preventDefault();
        return;
      }
      this.gestureSnapped = !1, this.deltaSinceSnap = 0;
    }
    if (this.isAnimating) {
      t.preventDefault();
      return;
    }
    const c = s, l = this.currentSection();
    if (!l) return;
    const h = this.controlledOf(l);
    if (h) {
      t.preventDefault(), h.smooth ? this.scrubSmooth(h, c, i) : this.scrubControlled(h, c, i);
      return;
    }
    if (this.hasInternalScrollRoom(l, c)) return;
    const d = this.currentIndex + c;
    if (d < 0 || d >= this.sections.length) {
      if (this.hasPageScrollRoom(c)) return;
      t.preventDefault(), d < 0 && !this.isAtRest(l) && this.snap(this.currentIndex);
      return;
    }
    t.preventDefault(), this.snap(d, c);
  }
  /* Drive the scroll through a controlled section (a pinned word-reveal, or the Our
   * Story parallax), clamped to its bounds. While there's room left in `dir` we
   * move the scrollbar — which scrubs the reveal / advances Our Story's blocks —
   * and once we reach the end/start we snap to the neighbour. Because the scroll is
   * clamped, the next section can't peek and pinned backgrounds don't drift. */
  scrubControlled(t, e, i) {
    t.refreshBounds();
    const s = window.scrollY;
    if (e > 0) {
      if (s < t.endHoldY - 0.5) {
        const r = Math.min(t.endHoldY, s + i);
        if (window.scrollTo(0, r), r < t.endHoldY - 0.5) return;
      }
      this.snap(this.currentIndex + 1, e);
    } else {
      if (s > t.startY + 0.5) {
        const r = Math.max(t.startY, s - i);
        if (window.scrollTo(0, r), r > t.startY + 0.5) return;
      }
      !this.snap(this.currentIndex - 1, e) && s > 0 && window.scrollTo(0, Math.max(0, s - i));
    }
  }
  /* Like scrubControlled, but eases the scroll POSITION toward an accumulated
   * target instead of jumping to it — for sections whose content moves with the
   * scroll (Our Story), so wheel/key input glides instead of stepping. Still
   * clamped to [startY, endY]; snaps once the target is pinned at an end and the
   * user keeps pushing that way. */
  scrubSmooth(t, e, i) {
    if (t.refreshBounds(), this.scrubRaf || (this.scrubTargetY = window.scrollY), e > 0 && this.scrubTargetY >= t.endY - 0.5) {
      this.endScrub(), this.snap(this.currentIndex + 1, e);
      return;
    }
    if (e < 0 && this.scrubTargetY <= t.startY + 0.5) {
      this.endScrub(), !this.snap(this.currentIndex - 1, e) && window.scrollY > 0 && window.scrollTo(0, Math.max(0, window.scrollY - i));
      return;
    }
    this.scrubTargetY = Math.min(t.endY, Math.max(t.startY, this.scrubTargetY + e * i)), this.scrubRaf || (this.scrubLastTs = 0, this.expectedScrollY = window.scrollY, this.scrubRaf = requestAnimationFrame(this.scrubStep));
  }
  scrubStep(t) {
    const e = this.scrubLastTs ? Math.min(64, t - this.scrubLastTs) : 16.67;
    this.scrubLastTs = t;
    const i = 1 - Math.pow(1 - this.scrubEase, e / 16.67), s = window.scrollY, r = this.scrubTargetY - s;
    if (Math.abs(r) < 0.5) {
      window.scrollTo(0, this.scrubTargetY), this.expectedScrollY = window.scrollY, this.scrubRaf = 0;
      return;
    }
    window.scrollTo(0, s + r * i), this.expectedScrollY = window.scrollY, this.scrubRaf = requestAnimationFrame(this.scrubStep);
  }
  endScrub() {
    cancelAnimationFrame(this.scrubRaf), this.scrubRaf = 0;
  }
  /* A section whose scroll we drive ourselves (clamped, then snap) rather than
   * snapping wholesale. Returns a bounds provider { startY, endY, endHoldY,
   * refreshBounds() } or null:
   *   - a pinned <kik-hero-reveal> (word reveal), or
   *   - an Our Story parallax (snap once its last block reaches the viewport
   *     centre — keeps its sticky background from drifting and the next section
   *     from peeking through the tail).  */
  controlledOf(t) {
    if (!t) return null;
    const e = t.querySelector("kik-hero-reveal");
    if (e && e.disabled === !1 && typeof e.refreshBounds == "function")
      return e;
    const i = t.querySelector(".kik-story");
    return i && !i.hasAttribute("data-static") ? this.storyBounds(t, i) : null;
  }
  storyBounds(t, e) {
    const i = e.querySelectorAll(".kik-story-block");
    if (!i.length) return null;
    const s = t.getBoundingClientRect().top + window.scrollY, r = Math.max(0, s - this.getHeaderHeight()), a = i[i.length - 1].getBoundingClientRect(), c = Math.max(r, a.top + a.height / 2 + window.scrollY - window.innerHeight / 2);
    return { startY: r, endY: c, endHoldY: c, smooth: !0, refreshBounds() {
    } };
  }
  onTouchStart(t) {
    const e = t.touches[0];
    this.snapDuration = this.animationDuration, this.scrubEase = 0.2, this.touchStartY = e.clientY, this.touchPrevY = e.clientY, this.touchStartTarget = t.target, this.touchIntercepted = !1;
  }
  onTouchMove(t) {
    if (!this.takesGestures() || !this.touchStartY || this.isTypingTarget(t.target) || this.isInsideScrollable(t.target)) return;
    const e = t.touches[0].clientY, i = this.currentSection();
    if (!i) return;
    const s = this.controlledOf(i);
    if (s) {
      const a = (this.touchPrevY == null ? this.touchStartY : this.touchPrevY) - e;
      if (this.touchPrevY = e, Math.abs(a) < 0.5) return;
      t.preventDefault(), this.isAnimating || this.scrubControlled(s, a > 0 ? 1 : -1, Math.abs(a));
      return;
    }
    const r = this.touchStartY - e;
    if (Math.abs(r) < this.touchThreshold) return;
    const o = r > 0 ? 1 : -1;
    if (!this.hasInternalScrollRoom(i, o)) {
      if (!this.touchIntercepted) {
        const a = this.currentIndex + o, c = a < 0 || a >= this.sections.length;
        if (c && this.hasPageScrollRoom(o)) return;
        this.touchIntercepted = !0, this.isAnimating || (c ? o < 0 && !this.isAtRest(i) && this.snap(this.currentIndex) : this.snap(a, o));
      }
      t.preventDefault();
    }
  }
  onTouchEnd() {
    this.touchStartY = 0, this.touchPrevY = null, this.touchIntercepted = !1;
  }
  snap(t, e, i) {
    if (t < 0 || t >= this.sections.length) return !1;
    const s = () => this.snapTargetY(t, e);
    if (t === this.currentIndex && Math.abs(window.scrollY - s()) < 2) return !1;
    this.currentIndex = t, this.isAnimating = !0, this.gestureSnapped = !0, this.deltaSinceSnap = 0;
    const r = i || this.snapDuration || this.animationDuration;
    return this.smoothScrollTo(s, r, e), clearTimeout(this.animationTimer), this.animationTimer = setTimeout(() => {
      this.isAnimating = !1;
    }, r + 60), !0;
  }
  /* Give up on the snap in flight and accept wherever the page ended up. */
  cancelSnap() {
    cancelAnimationFrame(this.rafHandle), this.rafHandle = 0, clearTimeout(this.animationTimer), this.animationTimer = 0, this.isAnimating = !1, this.currentIndex = this.findClosestIndex();
  }
  // Where to land when snapping to `index`. A reveal section entered from below
  // (dir < 0, i.e. scrolling up out of a later section) lands at its fully-revealed
  // bottom (endY) so the text is visible and scrolling up rewinds it; entered from
  // above it lands at the top (startY, = its normal resting position).
  snapTargetY(t, e) {
    const i = this.controlledOf(this.sections[t]);
    return i ? (i.refreshBounds(), e < 0 ? i.endY : i.startY) : this.targetScrollY(t);
  }
  targetScrollY(t) {
    if (t === 0) return 0;
    const s = this.sections[t].getBoundingClientRect().top + window.scrollY, r = this.getHeaderHeight(), o = document.documentElement.scrollHeight - window.innerHeight;
    return Math.max(0, Math.min(o, s - r));
  }
  getHeaderHeight() {
    if (this.cachedHeader && document.contains(this.cachedHeader))
      return this.cachedHeader.getBoundingClientRect().height;
    const t = document.querySelector(".kik-header-section") || document.querySelector("kik-header") || document.querySelector("[data-kik-header]");
    return t ? (this.cachedHeader = t, t.getBoundingClientRect().height) : 0;
  }
  /* Ease the scroll to wherever `getTarget()` says the section is — re-asked on
   * every frame, never captured up front.
   *
   * A snap lasts 600ms and a page is rarely finished settling: an image lands, a
   * font swaps, an app block injects itself, a section measures itself and grows.
   * Any of those moves the section we're travelling to. Interpolating toward a
   * document position frozen at gesture time lands the visitor where the section
   * used to be — usually the one before it — and because this loop writes
   * window.scrollTo every frame it also overwrites the browser's own scroll
   * anchoring, which would otherwise have absorbed the shift. Re-reading the
   * target costs a getBoundingClientRect per frame and always lands correctly.
   *
   * The starting position gets the same treatment. Interpolating from a `start`
   * captured once means every frame re-asserts it: any scroll we didn't make —
   * a trackpad's leftover inertia, a scrollbar drag, the browser's own anchoring
   * when a late image lands — is undone on the next frame, and the page visibly
   * jumps back toward where the gesture began before carrying on. So we watch
   * for the page moving without us and either re-base onto it, or, if it has
   * already carried past the target, hand it the win. */
  smoothScrollTo(t, e, i) {
    cancelAnimationFrame(this.rafHandle);
    let s = window.scrollY, r = performance.now();
    if (Math.abs(t() - s) < 1) return;
    const o = r + e;
    let a = s;
    const c = (h) => h < 0.5 ? 4 * h * h * h : 1 - Math.pow(-2 * h + 2, 3) / 2, l = (h) => {
      const d = t(), m = window.scrollY;
      if (Math.abs(m - a) > this.snapDriftTolerance) {
        if (i && (m - d) * i >= 0) {
          this.cancelSnap();
          return;
        }
        s = m, r = h;
      }
      const f = Math.min((h - r) / Math.max(1, o - r), 1);
      window.scrollTo(0, s + (d - s) * c(f)), a = window.scrollY, f < 1 ? this.rafHandle = requestAnimationFrame(l) : this.rafHandle = 0;
    };
    this.rafHandle = requestAnimationFrame(l);
  }
  isAtRest(t) {
    if (t === this.sections[0]) return window.scrollY < 2;
    const e = t.getBoundingClientRect(), i = this.getHeaderHeight();
    return Math.abs(e.top - i) < 2;
  }
  hasPageScrollRoom(t) {
    const e = document.documentElement.scrollHeight - window.innerHeight;
    return t > 0 ? window.scrollY < e - this.edgeTolerance : window.scrollY > this.edgeTolerance;
  }
  hasInternalScrollRoom(t, e) {
    const i = t.getBoundingClientRect();
    return i.height <= window.innerHeight + this.edgeTolerance ? !1 : e > 0 ? i.bottom > window.innerHeight + this.edgeTolerance : i.top < -this.edgeTolerance;
  }
  isInsideScrollable(t) {
    let e = t;
    for (; e && e !== document.body && e !== document.documentElement; ) {
      if (e.nodeType === 1) {
        const i = getComputedStyle(e).overflowY;
        if ((i === "auto" || i === "scroll") && e.scrollHeight > e.clientHeight + 1)
          return !0;
      }
      e = e.parentNode;
    }
    return !1;
  }
  isTypingTarget(t) {
    if (!t) return !1;
    const e = t.tagName;
    return !!(e === "INPUT" || e === "TEXTAREA" || e === "SELECT" || t.isContentEditable);
  }
}
customElements.get("kik-brand-story-scroll") || customElements.define("kik-brand-story-scroll", Z);
class tt extends HTMLElement {
  connectedCallback() {
    if (this.dataset.init === "1") return;
    this.dataset.init = "1", this.words = Array.from(this.querySelectorAll("[data-kik-reveal-word]")), this.baseOpacity = this._num(this.dataset.baseOpacity, 0), this.blurStrength = this._num(this.dataset.blur, 4), this.baseRotation = this._num(this.dataset.rotation, 3), this.distance = Math.max(1, this._num(this.dataset.distance, 900)), this.holdPx = Math.max(0, this._num(this.dataset.holdDistance, 100)), this.feather = 3, this.smoothing = Math.min(1, Math.max(0.02, this._num(this.dataset.smoothing, 0.12))), this.panel = this.closest("section") || this, this.track = this.panel.parentElement || this.panel, this.entryMode = this.dataset.revealMode === "entry";
    const t = window.matchMedia("(prefers-reduced-motion: reduce)").matches, e = this.hasAttribute("data-static") || !!this.closest("[data-static]");
    if (t || e || !this.words.length) {
      this.disabled = !0, this.startY = 0, this.endY = 0, this.applyFull();
      return;
    }
    if (this.entryMode) {
      this.disabled = !0, this.startY = 0, this.endY = 0, this.endHoldY = 0, this.current = 0, this._render(0), this.entryDuration = Math.max(400, this._num(this.dataset.entryDuration, 900)), this._entryTick = this._entryTick.bind(this), this._entryObserver = new IntersectionObserver((i) => {
        i.some((s) => s.isIntersecting) && this.startEntryReveal();
      }, { threshold: 0.35 }), this._entryObserver.observe(this.panel);
      return;
    }
    this.disabled = !1, this._raf = 0, this._running = !1, this._lastTs = 0, this.onScroll = this.onScroll.bind(this), this.onResize = this.onResize.bind(this), this._tick = this._tick.bind(this), this.layout(), this.current = this.target = this.progressFromScroll(), this._render(this.current), window.addEventListener("scroll", this.onScroll, { passive: !0 }), window.addEventListener("resize", this.onResize);
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScroll), window.removeEventListener("resize", this.onResize), cancelAnimationFrame(this._raf), cancelAnimationFrame(this._entryRaf), this._entryObserver?.disconnect(), this._running = !1;
  }
  startEntryReveal() {
    this._entryStarted || (this._entryStarted = !0, this._entryStart = 0, this._entryObserver?.disconnect(), this._entryRaf = requestAnimationFrame(this._entryTick));
  }
  _entryTick(t) {
    this._entryStart || (this._entryStart = t);
    const e = Math.min(1, (t - this._entryStart) / this.entryDuration), i = 1 - Math.pow(1 - e, 3);
    this._render(i), e < 1 && (this._entryRaf = requestAnimationFrame(this._entryTick));
  }
  _num(t, e) {
    const i = parseFloat(t);
    return Number.isFinite(i) ? i : e;
  }
  headerHeight() {
    const t = document.querySelector(".kik-header-section") || document.querySelector("kik-header") || document.querySelector("[data-kik-header]");
    return t ? t.getBoundingClientRect().height : 0;
  }
  /* Pin the panel at the header offset (so it sits below the sticky header from
   * the start). The panel keeps its design height — we do NOT stretch it to the
   * viewport — and the scrollbar travels the extra track height that sits below
   * it inside the same wrapper. */
  layout() {
    this.pinTop = this.dataset.kikPinTop === "0" ? 0 : this.headerHeight(), this.panel.style.position = "sticky", this.panel.style.top = this.pinTop + "px", this.reserveTrack(), this.refreshBounds();
  }
  /* The track has to be `panel height + distance + hold` tall for the panel to
   * stay pinned through the whole reveal AND the post-reveal hold. Sections
   * reserve that room in their own markup (a spacer element next to the panel,
   * inside the .shopify-section wrapper) so the document is already at its final
   * height on first paint. Growing it from here instead pushes every later
   * section down the moment the bundle finishes loading — a visitor who started
   * scrolling during load keeps their scroll position but not their place, so
   * the page appears to jump back toward the top.
   *
   * A section that ships no spacer still works: we add the missing room, and
   * keep the visitor on whatever they were looking at while we do it. */
  reserveTrack() {
    const e = this.panel.getBoundingClientRect().height + this.distance + this.holdPx, i = this.track.getBoundingClientRect();
    if (i.height >= e - 1) return;
    const s = i.bottom + window.scrollY, r = e - i.height;
    this.track.style.minHeight = e + "px", window.scrollY > s && window.scrollTo(0, window.scrollY + r);
  }
  /* startY / endY = scroll positions at which the reveal is 0 and 1. startY is
   * where the panel begins pinning (clamped to 0 for the first section, which
   * already sits at the top of the page). */
  refreshBounds() {
    const t = this.track.getBoundingClientRect().top + window.scrollY;
    this.startY = Math.max(0, t - this.pinTop), this.endY = this.startY + this.distance, this.endHoldY = this.endY + this.holdPx;
  }
  onResize() {
    this.disabled || (this.layout(), this.target = this.progressFromScroll(), this._ensureLoop());
  }
  onScroll() {
    this.disabled || (this.target = this.progressFromScroll(), this._ensureLoop());
  }
  // Target reveal progress (0..1) for the current scroll position.
  progressFromScroll() {
    return this.refreshBounds(), Math.min(1, Math.max(0, (window.scrollY - this.startY) / this.distance));
  }
  /* Ease the rendered progress toward the scroll-derived target. Exponential
   * smoothing scaled by real elapsed time, so the glide feels the same at 60 or
   * 144fps. Stops itself once it's caught up. */
  _ensureLoop() {
    this._running || (this._running = !0, this._lastTs = 0, this._raf = requestAnimationFrame(this._tick));
  }
  _tick(t) {
    const e = this._lastTs ? Math.min(64, t - this._lastTs) : 16.67;
    this._lastTs = t;
    const i = 1 - Math.pow(1 - this.smoothing, e / 16.67), s = this.target - this.current;
    if (Math.abs(s) < 5e-4) {
      this.current = this.target, this._render(this.current), this._running = !1;
      return;
    }
    this.current += s * i, this._render(this.current), this._raf = requestAnimationFrame(this._tick);
  }
  applyFull() {
    this.style.setProperty("--kik-reveal-rot", "0deg"), this.words.forEach((t) => {
      t.style.opacity = "1", t.style.filter = "none";
    });
  }
  _render(t) {
    t = Math.min(1, Math.max(0, t));
    const e = this.words.length, i = this.feather, s = t * (e + i);
    this.style.setProperty("--kik-reveal-rot", (this.baseRotation * (1 - t)).toFixed(3) + "deg");
    for (let r = 0; r < e; r++) {
      const o = Math.min(1, Math.max(0, (s - r) / i)), a = this.words[r];
      a.style.opacity = (this.baseOpacity + (1 - this.baseOpacity) * o).toFixed(3), a.style.filter = o >= 1 ? "none" : "blur(" + (this.blurStrength * (1 - o)).toFixed(2) + "px)";
    }
  }
}
customElements.get("kik-hero-reveal") || customElements.define("kik-hero-reveal", tt);
const et = 0.25;
class it extends HTMLElement {
  connectedCallback() {
    this.radios = Array.from(this.querySelectorAll(".kik-belief-radio")), this.radios.length && (this.autoplay = this.dataset.autoplay === "true", this.durations = this.radios.map((t, e) => {
      const i = this.querySelector(`.kik-belief-step[data-i="${e + 1}"]`), s = i ? parseFloat(i.dataset.duration) : NaN;
      return (Number.isFinite(s) && s > 0 ? s : 6) * 1e3;
    }), this.index = Math.max(0, this.radios.findIndex((t) => t.checked)), this.inView = !1, this.remaining = null, this.radios.forEach((t, e) => {
      t.addEventListener("change", () => {
        t.checked && (this.index = e, this.syncMedia(), this.restart());
      });
    }), this.addEventListener("mouseenter", () => this.stop()), this.addEventListener("mouseleave", () => this.start()), this.addEventListener("focusin", () => this.stop()), this.addEventListener("focusout", () => this.start()), this._onVisibility = () => document.hidden ? this.stop() : this.start(), document.addEventListener("visibilitychange", this._onVisibility), "IntersectionObserver" in window ? (this._observer = new IntersectionObserver(
      (t) => {
        t.forEach((e) => {
          e.isIntersecting !== this.inView && (this.inView = e.isIntersecting, this.inView ? (this.syncMedia(), this.start()) : (this.stop(), this.syncMedia()));
        });
      },
      { threshold: et }
    ), this._observer.observe(this)) : this.inView = !0, this.syncMedia(), this.inView && this.start());
  }
  disconnectedCallback() {
    this.stop(), this._observer && this._observer.disconnect(), this._onVisibility && document.removeEventListener("visibilitychange", this._onVisibility);
  }
  prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }
  /* Play the active step's video, pause every other one. Off screen, nothing
     plays — `active` matches no step. */
  syncMedia() {
    const t = this.inView ? String(this.index + 1) : null;
    this.querySelectorAll("video[data-i]").forEach((e) => {
      if (e.dataset.i === t) {
        const i = e.play();
        i && i.catch && i.catch(() => {
        });
      } else
        e.pause();
    });
  }
  next() {
    const t = this.radios[(this.index + 1) % this.radios.length];
    t && (t.checked = !0, t.dispatchEvent(new Event("change", { bubbles: !0 })));
  }
  duration() {
    return this.durations[this.index] || 6e3;
  }
  start() {
    if (!this.inView || (this.removeAttribute("data-paused"), !this.autoplay || this.timer || this.radios.length < 2) || this.prefersReducedMotion()) return;
    const t = this.remaining == null ? this.duration() : this.remaining;
    this.startedAt = Date.now(), this.timer = window.setTimeout(() => {
      this.timer = null, this.remaining = null, this.next();
    }, Math.max(0, t));
  }
  stop() {
    if (this.setAttribute("data-paused", ""), this.timer) {
      const t = this.remaining == null ? this.duration() : this.remaining;
      this.remaining = Math.max(0, t - (Date.now() - this.startedAt)), window.clearTimeout(this.timer), this.timer = null;
    }
  }
  /* Called after the active step changed — stop() first, so the time it banks
     belongs to the step that just ended, then clear it for the new one. */
  restart() {
    this.stop(), this.remaining = null, this.start();
  }
}
customElements.get("kik-belief-slides") || customElements.define("kik-belief-slides", it);
const p = ["bf", "combo", "ff"];
function st(n, t, e) {
  if (!p.includes(t))
    throw new Error("Quiz return URL requires a valid result key.");
  const i = new URL(n, "https://example.com");
  return i.searchParams.delete("customer_posted"), i.searchParams.delete("quiz_result"), i.searchParams.set("quiz_result", t), i.searchParams.set("customer_posted", "true"), i.hash = `kik-feeding-quiz-${e}`, `${i.pathname}${i.search}${i.hash}`;
}
function rt(n) {
  const t = new URLSearchParams(n), e = t.get("quiz_result");
  return t.get("customer_posted") === "true" && p.includes(e) ? e : null;
}
function ot(n) {
  const t = new URLSearchParams(n).get("quiz_preview_result");
  return p.includes(t) ? t : null;
}
function C() {
  return {
    stage: "questions",
    currentIndex: 0,
    answers: {},
    resultKey: null
  };
}
function nt(n) {
  if (!n || !Array.isArray(n.questions) || n.questions.length !== 6)
    throw new Error("Quiz data must contain exactly 6 questions.");
  for (const t of n.questions) {
    if (!t?.id || !Array.isArray(t.answers) || t.answers.length !== 3)
      throw new Error("Every question must contain an id and exactly 3 answers.");
    for (const e of t.answers) {
      if (!e?.id || !e.scores)
        throw new Error("Every answer must contain an id and score vector.");
      for (const i of p)
        if (!Number.isFinite(e.scores[i]))
          throw new Error(`Every answer must contain a numeric ${i} score.`);
    }
  }
  if (!n.results || p.some((t) => !n.results[t]))
    throw new Error("Quiz data must contain bf, combo, and ff results.");
  return !0;
}
function at(n, t) {
  const e = { bf: 0, combo: 0, ff: 0 };
  for (const i of n) {
    const s = t?.[i.id], r = i.answers.find((o) => o.id === s);
    if (!r)
      throw new Error("Every question must have one answer before scoring.");
    for (const o of p)
      e[o] += r.scores[o];
  }
  return e;
}
function ct(n) {
  const t = Math.max(...p.map((i) => n[i])), e = p.filter((i) => n[i] === t);
  return e.length > 1 ? "combo" : e[0];
}
const lt = "flex min-h-[48px] w-full cursor-pointer items-center justify-center rounded-[100px] bg-[#e5f7a1] px-[40px] py-[12px] text-center text-[14px] font-bold leading-[1.5] text-[#1b1b1b] transition-colors hover:bg-[#d8ed87] peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-4 lg:text-[16px]", ht = "ring-2 ring-[#1b1b1b] ring-offset-2";
class dt extends HTMLElement {
  connectedCallback() {
    if (!this.hasAttribute("data-initialized")) {
      this.setAttribute("data-initialized", ""), this.abortController = new AbortController();
      try {
        this.data = JSON.parse(this.querySelector("[data-quiz-data]")?.textContent || ""), nt(this.data), this.collectElements(), this.state = C(), this.applyReturnState(), this.bindEvents(), this.render();
      } catch (t) {
        this.showRuntimeError(t);
      }
    }
  }
  disconnectedCallback() {
    this.abortController?.abort(), this.removeAttribute("data-initialized");
  }
  collectElements() {
    this.stages = Object.fromEntries(
      [...this.querySelectorAll("[data-quiz-stage]")].map((t) => [
        t.dataset.quizStage,
        t
      ])
    ), this.questionHeading = this.querySelector("[data-quiz-question]"), this.answersContainer = this.querySelector("[data-quiz-answers]"), this.progressElements = [...this.querySelectorAll("[data-quiz-progress]")], this.previousButtons = [...this.querySelectorAll('[data-quiz-action="previous"]')], this.nextButtons = [...this.querySelectorAll('[data-quiz-action="next"]')], this.emailHeading = this.querySelector("[data-quiz-email-heading]"), this.emailBody = this.querySelector("[data-quiz-email-body]"), this.emailInput = this.querySelector("[data-quiz-email]"), this.submitButton = this.querySelector("[data-quiz-submit]"), this.privacyIntro = this.querySelector("[data-quiz-privacy-intro]"), this.privacyLink = this.querySelector("[data-quiz-privacy-link]"), this.form = this.querySelector("form.kik-feeding-quiz-form"), this.returnToInput = this.querySelector("[data-quiz-return-to]"), this.formStatus = this.querySelector("[data-quiz-form-status]"), this.resultImage = this.querySelector("[data-quiz-result-image]"), this.resultTitle = this.querySelector("[data-quiz-result-title]"), this.resultBody = this.querySelector("[data-quiz-result-body]"), this.tipsHeading = this.querySelector("[data-quiz-tips-heading]"), this.tipsList = this.querySelector("[data-quiz-tips]"), this.tipTemplate = this.querySelector("[data-quiz-tip-template]"), this.expertCredit = this.querySelector("[data-quiz-expert-credit]"), this.runtimeError = this.querySelector("[data-quiz-runtime-error]");
  }
  bindEvents() {
    const { signal: t } = this.abortController;
    this.addEventListener("click", (e) => this.handleClick(e), { signal: t }), this.addEventListener("change", (e) => this.handleChange(e), { signal: t }), this.addEventListener(
      "submit",
      (e) => {
        e.target === this.form && this.handleSubmit(e);
      },
      { capture: !0, signal: t }
    );
  }
  applyReturnState() {
    const t = ot(window.location.search) || rt(window.location.search);
    t && (this.state.stage = "result", this.state.resultKey = t);
  }
  handleClick(t) {
    const e = t.target.closest("[data-quiz-action]");
    if (!(!e || e.disabled))
      switch (e.dataset.quizAction) {
        case "previous":
          this.moveQuestion(-1);
          break;
        case "next":
          this.moveQuestion(1);
          break;
        case "email-previous":
          this.state.stage = "questions", this.state.currentIndex = this.data.questions.length - 1, this.render({ focus: !0 });
          break;
        case "restart":
          this.restart();
          break;
      }
  }
  handleChange(t) {
    const e = t.target.closest("[data-quiz-answer]");
    if (!e) return;
    const i = this.data.questions[this.state.currentIndex];
    this.state.answers[i.id] = e.value, this.moveQuestion(1);
  }
  moveQuestion(t) {
    const e = this.data.questions[this.state.currentIndex];
    t > 0 && !this.state.answers[e.id] || (t < 0 ? this.state.currentIndex = Math.max(0, this.state.currentIndex - 1) : this.state.currentIndex === this.data.questions.length - 1 ? this.state.stage = "email" : this.state.currentIndex += 1, this.render({ focus: !0 }));
  }
  handleSubmit(t) {
    try {
      const e = at(this.data.questions, this.state.answers), i = ct(e);
      this.returnToInput.value = st(
        window.location.href,
        i,
        this.dataset.sectionId
      ), this.setFormStatus("");
    } catch (e) {
      t.preventDefault(), t.stopPropagation(), this.showRuntimeError(e);
    }
  }
  setFormStatus(t, e = !1) {
    this.formStatus && (this.formStatus.textContent = t, this.formStatus.classList.toggle("hidden", !t), this.formStatus.classList.toggle("text-[#c92a2a]", !!(t && e)));
  }
  restart() {
    this.state = C();
    const t = new URL(window.location.href);
    t.searchParams.delete("customer_posted"), t.searchParams.delete("quiz_result"), t.searchParams.delete("quiz_preview_result"), window.history.replaceState({}, "", `${t.pathname}${t.search}${t.hash}`), this.emailInput && (this.emailInput.value = ""), this.setFormStatus(""), this.render({ focus: !0 });
  }
  render(t = {}) {
    this.showStage(this.state.stage), this.renderEmailCopy(), this.state.stage === "questions" ? (this.renderQuestion(), t.focus && this.focusElement(this.questionHeading)) : this.state.stage === "email" ? t.focus && this.focusElement(this.emailHeading) : this.state.stage === "result" && (this.renderResult(), t.focus && this.focusElement(this.resultTitle));
  }
  showStage(t) {
    for (const [e, i] of Object.entries(this.stages)) {
      const s = e === t;
      i.classList.toggle("hidden", !s), (e === "email" || e === "result") && i.classList.toggle("flex", s);
    }
  }
  renderQuestion() {
    const t = this.data.questions[this.state.currentIndex], e = this.state.answers[t.id], i = this.data.labels.progress.replace("{current}", String(this.state.currentIndex + 1)).replace("{total}", String(this.data.questions.length));
    this.questionHeading.textContent = `${this.state.currentIndex + 1}. ${t.question}`, this.progressElements.forEach((s) => {
      s.textContent = i;
    }), this.answersContainer.replaceChildren(
      ...t.answers.map((s) => {
        const r = document.createElement("label");
        r.className = "block w-full";
        const o = document.createElement("input");
        o.className = "peer sr-only", o.type = "radio", o.name = `quiz-${t.id}`, o.value = s.id, o.checked = e === s.id, o.dataset.quizAnswer = "";
        const a = document.createElement("span");
        return a.className = `${lt}${o.checked ? ` ${ht}` : ""}`, a.textContent = s.label, r.append(o, a), r;
      })
    ), this.previousButtons.forEach((s) => {
      s.disabled = this.state.currentIndex === 0, s.setAttribute("aria-disabled", String(s.disabled));
    }), this.nextButtons.forEach((s) => {
      s.disabled = !e, s.setAttribute("aria-disabled", String(s.disabled));
    });
  }
  renderEmailCopy() {
    this.emailHeading.textContent = this.data.labels.emailHeading, this.emailBody.textContent = this.data.labels.emailBody, this.emailInput.placeholder = this.data.labels.emailPlaceholder, this.privacyIntro.textContent = `${this.data.labels.privacyIntro} `, this.privacyLink.textContent = this.data.labels.privacyLabel, this.privacyLink.href = this.data.labels.privacyUrl, this.submitButton && (this.submitButton.textContent = this.data.labels.submit);
  }
  renderResult() {
    const t = this.data.results[this.state.resultKey];
    if (!t) throw new Error("The calculated result is missing from quiz data.");
    this.resultImage.src = t.image, this.resultImage.alt = t.imageAlt, this.resultTitle.textContent = t.title, this.resultBody.textContent = t.body, this.tipsHeading.textContent = this.data.labels.tipsHeading, this.expertCredit.textContent = this.data.labels.expertCredit;
    const e = t.tips.map((i) => {
      const s = this.tipTemplate.content.cloneNode(!0);
      return s.querySelector("[data-quiz-tip-text]").textContent = i, s;
    });
    this.tipsList.replaceChildren(...e);
  }
  focusElement(t) {
    window.requestAnimationFrame(() => t?.focus({ preventScroll: !0 }));
  }
  showRuntimeError(t) {
    const e = t instanceof Error ? t.message : "The quiz could not be initialized.";
    this.querySelectorAll("[data-quiz-stage]").forEach((s) => {
      s.classList.add("hidden"), s.classList.remove("flex");
    });
    const i = this.runtimeError || this.querySelector("[data-quiz-runtime-error]");
    i && (i.textContent = e, i.classList.remove("hidden"));
  }
}
customElements.get("kik-feeding-quiz") || customElements.define("kik-feeding-quiz", dt);
class ut extends HTMLElement {
  connectedCallback() {
    if (this.card = this.closest(".kik-fc-card, [data-kik-search-card]"), !this.card) return;
    this.buttons = Array.from(this.querySelectorAll("[data-kik-fc-swatch]")), this.buttons.forEach((e) => {
      e.addEventListener("click", (i) => {
        i.preventDefault(), i.stopPropagation(), this.selectSwatch(e);
      });
    });
    const t = this.parentElement?.querySelector("[data-kik-fc-swatch-next]");
    t && t.addEventListener("click", (e) => {
      e.preventDefault(), e.stopPropagation(), this.scrollLeft >= this.scrollWidth - this.clientWidth - 2 ? this.scrollTo({ left: 0, behavior: "smooth" }) : this.scrollBy({ left: this.clientWidth * 0.7, behavior: "smooth" });
    });
  }
  selectSwatch(t) {
    const e = t.dataset, i = this.card.querySelector("[data-kik-fc-image]");
    i && e.image && (i.src = e.image, e.imageSrcset && (i.srcset = e.imageSrcset));
    const s = this.card.querySelector("[data-kik-fc-price]");
    s && e.price && (s.innerHTML = e.price), e.variantUrl && this.card.querySelectorAll('a[href*="/products/"]').forEach((c) => {
      c.href = e.variantUrl;
    });
    const r = this.card.querySelector("[data-kik-fc-badges]");
    if (r && e.badges != null)
      try {
        r.innerHTML = JSON.parse(e.badges);
      } catch {
      }
    const o = this.card.querySelector("[data-kik-fc-after]");
    if (o && e.after != null)
      try {
        o.innerHTML = JSON.parse(e.after);
      } catch {
      }
    const a = this.card.querySelector("[data-kik-fc-variant-input]");
    if (a && e.variantId && (a.value = e.variantId), this.card.hasAttribute("data-kik-search-card")) {
      e.priceHtml && this.card.querySelectorAll(".price").forEach((l) => {
        l.outerHTML = e.priceHtml;
      });
      const c = this.card.querySelector("[data-kik-search-add]");
      if (c) {
        c.disabled = e.available !== "true";
        const l = c.disabled ? c.dataset.soldOutText : c.dataset.addToCartText;
        c.querySelectorAll(".quick-add-btn-text, .visually-hidden").forEach((h) => {
          h.textContent = l;
        });
      }
    }
    this.buttons.forEach((c) => {
      const l = c === t;
      c.setAttribute("aria-checked", l ? "true" : "false"), c.classList.toggle("is-active", l);
    });
  }
}
customElements.define("kik-fc-swatches", ut);
const T = window.KikTheme ?? {
  ready: !1,
  version: "0.1.0"
}, v = () => {
  T.ready = !0, document.documentElement.dataset.kikTheme = "ready";
};
window.KikTheme = T;
document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", v, { once: !0 }) : v();
document.addEventListener("shopify:section:load", v);
class mt extends HTMLElement {
  connectedCallback() {
    this.closeTimer = null, this.bindDesktop(), this.bindTabs(), this.bindMobile(), this.bindScrim(), this.bindWishlist(), this.publishStickyHeight(), this.bindScrollShadow(), this._onKey = (t) => {
      t.key === "Escape" && (this.closeAll(), this.closeDrawer());
    }, document.addEventListener("keydown", this._onKey);
  }
  /* Wishlist icon — SE Wishlist Engine injects its own floating "My
   * wishlist" launcher and hooks whatever selector the merchant
   * configures in the app dashboard (typically `.wishlist-menu-btn`).
   * Rather than guessing the exact selector, forward the header icon's
   * click to the app's floating launcher when it's present. Fallback:
   * let the href navigate normally. */
  bindWishlist() {
    this.querySelectorAll("a.wishlist-menu-btn").forEach((t) => {
      t.addEventListener("click", (e) => {
        if (e.defaultPrevented) return;
        const i = [
          ".se-wishlist-floating-btn",
          "#se-wishlist-floating",
          "[data-se-wishlist-open]",
          "[data-wishlist-open]",
          ".wishlist-launcher",
          ".se-wl-launcher",
          ".se-wl-fab",
          "[data-swe-wishlist]"
        ];
        for (const s of i) {
          const r = document.querySelectorAll(s);
          for (const o of r)
            if (o !== t && !t.contains(o) && !this.contains(o)) {
              e.preventDefault(), o.click();
              return;
            }
        }
      });
    });
  }
  disconnectedCallback() {
    document.removeEventListener("keydown", this._onKey), this._onResize && window.removeEventListener("resize", this._onResize), this._onScroll && window.removeEventListener("scroll", this._onScroll), this._headerResizeObserver?.disconnect(), window.removeEventListener("resize", this._onHeaderResize), window.removeEventListener("scroll", this._onHeaderScroll);
  }
  /* Publish the visible top stack's bottom edge for immersive sections. At the
   * homepage top this includes the announcement bar above the sticky header;
   * after scrolling it naturally contracts to the header's own height. */
  publishStickyHeight() {
    const t = this.closest(".kik-header-section") || this, e = () => {
      const i = t.getBoundingClientRect(), s = Math.max(i.height, i.bottom, 0);
      document.documentElement.style.setProperty("--kik-sticky-header-height", `${Math.ceil(s)}px`);
    };
    this._onHeaderResize = e, this._onHeaderScroll = e, "ResizeObserver" in window && (this._headerResizeObserver = new ResizeObserver(e), this._headerResizeObserver.observe(t)), window.addEventListener("resize", this._onHeaderResize, { passive: !0 }), window.addEventListener("scroll", this._onHeaderScroll, { passive: !0 }), e();
  }
  /* Sticky nav shadow — the header is flush with the page while at the
   * top, then a subtle shadow appears after any scroll so the sticky
   * header separates from the content sliding beneath it. Threshold of
   * 4px avoids a flash on the smallest bounce/momentum scrolls. */
  bindScrollShadow() {
    this._onScroll = () => {
      this.toggleAttribute("data-scrolled", window.scrollY > 4);
    }, window.addEventListener("scroll", this._onScroll, { passive: !0 }), this._onScroll();
  }
  /* ---- Desktop page scrim — dims the page below the header while any
   * mega is open. The scrim is `absolute top-full` inside the sticky
   * <kik-header>, so it auto-tracks the header's bottom edge as the
   * page scrolls — no height measurement or scroll listener needed.
   * Clicking the scrim closes the mega. */
  bindScrim() {
    this.scrim = this.querySelector("[data-kik-scrim]"), this.scrim && (this.scrim.classList.remove("hidden"), this.scrim.addEventListener("click", () => this.closeAll()));
  }
  /* ---- Desktop mega menu open/close ---- */
  bindDesktop() {
    this.panels = Array.from(this.querySelectorAll("[data-mega-panel]")), this.navItems = Array.from(this.querySelectorAll("[data-nav-item]")), this.navItems.forEach((t) => {
      const e = t.getAttribute("data-nav-item"), i = t.querySelector("[data-nav-trigger]"), s = () => this.openPanel(e, i);
      t.addEventListener("mouseenter", s), i && (i.addEventListener("focus", s), i.addEventListener("click", (r) => {
        (i.getAttribute("href") === "#" || !i.getAttribute("href")) && (r.preventDefault(), this.isOpen(e) ? this.closeAll() : s());
      }));
    }), this.panels.forEach((t) => {
      t.addEventListener("mouseenter", () => this.cancelClose()), t.addEventListener("mouseleave", () => this.scheduleClose());
    }), this.navItems.forEach((t) => {
      t.addEventListener("mouseleave", () => this.scheduleClose());
    }), document.addEventListener("click", (t) => {
      this.contains(t.target) || this.closeAll();
    });
  }
  panelFor(t) {
    return this.querySelector(`[data-mega-panel="${t}"]`);
  }
  isOpen(t) {
    const e = this.panelFor(t);
    return e && !e.classList.contains("hidden");
  }
  openPanel(t, e) {
    this.cancelClose(), this.panels.forEach((i) => {
      const s = i.getAttribute("data-mega-panel") === t;
      i.classList.toggle("hidden", !s);
    }), this.querySelectorAll("[data-nav-trigger]").forEach(
      (i) => i.setAttribute("aria-expanded", i === e ? "true" : "false")
    ), this.setAttribute("data-mega-open", "");
  }
  closeAll() {
    this.panels && (this.panels.forEach((t) => t.classList.add("hidden")), this.querySelectorAll("[data-nav-trigger]").forEach((t) => t.setAttribute("aria-expanded", "false")), this.removeAttribute("data-mega-open"));
  }
  scheduleClose() {
    this.cancelClose(), this.closeTimer = window.setTimeout(() => this.closeAll(), 180);
  }
  cancelClose() {
    this.closeTimer && (window.clearTimeout(this.closeTimer), this.closeTimer = null);
  }
  /* ---- Tab switching (shared desktop + mobile) ---- */
  bindTabs() {
    this.querySelectorAll("[data-tab-trigger]").forEach((t) => {
      t.addEventListener("click", () => {
        const e = t.getAttribute("data-group"), i = t.getAttribute("data-tab-trigger");
        this.querySelectorAll(`[data-tab-trigger][data-group="${e}"]`).forEach((r) => {
          const o = r === t;
          r.toggleAttribute("data-active", o), r.classList.toggle("bg-alt-2", o);
        });
        const s = this.querySelector(`[data-tab-content="${e}"]`);
        s && s.querySelectorAll("[data-tab-panel]").forEach((r) => {
          r.classList.toggle("hidden", r.getAttribute("data-tab-panel") !== i);
        });
      });
    });
  }
  /* ---- Mobile menu (full-width panel below the header) ---- */
  bindMobile() {
    this.drawer = this.querySelector("[data-mobile-drawer]"), this.mobileHeader = this.querySelector("[data-mobile-header]");
    const t = this.querySelector("[data-mobile-toggle]");
    t && t.addEventListener("click", () => this.toggleDrawer(t)), this.querySelectorAll("[data-mobile-close]").forEach(
      (s) => s.addEventListener("click", () => this.closeDrawer())
    ), this.querySelectorAll("[data-mobile-submenu-open]").forEach(
      (s) => s.addEventListener("click", () => this.showSubmenu(s.getAttribute("data-mobile-submenu-open")))
    ), this.querySelectorAll("[data-mobile-back]").forEach(
      (s) => s.addEventListener("click", () => this.hideSubmenus())
    ), this.querySelectorAll("[data-mobile-accordion]").forEach(
      (s) => s.addEventListener("click", () => this.toggleAccordion(s))
    ), this._onResize = () => {
      this.drawer && !this.drawer.classList.contains("hidden") && this.anchorDrawer();
    }, window.addEventListener("resize", this._onResize);
    const e = this.querySelector("[data-mobile-search-toggle]"), i = this.querySelector("[data-mobile-search]");
    e && i && e.addEventListener("click", () => i.querySelector("input")?.focus());
  }
  toggleDrawer(t) {
    this.drawer && (this.drawer.classList.contains("hidden") ? this.openDrawer(t) : this.closeDrawer());
  }
  // Pin the panel's top edge to the bottom of the sticky header so it drops
  // in directly under the search bar (the header stays visible above it).
  anchorDrawer() {
    if (!this.drawer || !this.mobileHeader) return;
    const t = this.mobileHeader.getBoundingClientRect().bottom;
    this.drawer.style.top = Math.max(0, t) + "px";
  }
  openDrawer(t) {
    this.drawer && (this.mobileHeader?.setAttribute("data-drawer-open", ""), this.anchorDrawer(), this.drawer.classList.remove("hidden"), document.documentElement.style.overflow = "hidden", t?.setAttribute("aria-expanded", "true"));
  }
  closeDrawer() {
    this.drawer && (this.hideSubmenus(), this.drawer.classList.add("hidden"), this.mobileHeader?.removeAttribute("data-drawer-open"), document.documentElement.style.overflow = "", this.querySelector("[data-mobile-toggle]")?.setAttribute("aria-expanded", "false"));
  }
  showSubmenu(t) {
    const e = this.querySelector(`[data-mobile-submenu="${t}"]`);
    e && (e.classList.remove("hidden"), e.classList.add("flex"));
  }
  hideSubmenus() {
    this.querySelectorAll("[data-mobile-submenu]").forEach((t) => {
      t.classList.add("hidden"), t.classList.remove("flex");
    });
  }
  toggleAccordion(t) {
    const e = t.getAttribute("data-mobile-accordion"), i = this.querySelector(`[data-mobile-accordion-panel="${e}"]`);
    if (!i) return;
    const s = i.classList.contains("hidden");
    i.classList.toggle("hidden", !s), i.classList.toggle("flex", s), t.setAttribute("aria-expanded", s ? "true" : "false");
    const r = t.querySelector(".kik-acc-chevron");
    r && (r.style.transform = s ? "rotate(90deg)" : "");
  }
}
customElements.get("kik-header") || customElements.define("kik-header", mt);
class ft extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll(".kik-footer-col-toggle").forEach((t) => {
      t.addEventListener("click", () => {
        const e = t.closest("[class*='flex-col']"), i = e && e.querySelector(".kik-footer-col-body"), s = t.querySelector(".kik-footer-col-chevron");
        if (!i) return;
        const o = !i.classList.toggle("hidden");
        t.setAttribute("aria-expanded", o ? "true" : "false"), s && (s.style.transform = o ? "rotate(180deg)" : "");
      });
    });
  }
}
customElements.get("kik-footer") || customElements.define("kik-footer", ft);
